/**
 * @file 简体中文话术
 * @author zhujialu
 */
define(function (require, exports) {
    'use strict'

    /**
     * =================================================
     * 用户角色
     * =================================================
     */

    exports.USER_ROLE_TEACHER = '老師'

    exports.USER_ROLE_STUDENT = '學生'

    exports.USER_ROLE_GUEST = '遊客'

    exports.USER_ROLE_ASSISTANT = '助教'

    exports.USER_ROLE_SPECIAL_GUEST = '嘉賓'

    exports.USER_ASSISTANT_NUMBER = '助教${number}'

    /**
     * =================================================
     * 老师状态
     * =================================================
     */

    exports.TEACHER_UNKNOW = '老師未進入教室'

    exports.TEACHER_IN = '老師已進入教室'

    exports.TEACHER_OUT = '老師已離開教室'

    exports.TEACHER_AUDIO_ON = '老師已開麥克風'

    exports.TEACHER_AUDIO_OFF = '老師已關麥克風'

    exports.TEACHER_VIDEO_ON = '老師已開監視器'

    exports.TEACHER_VIDEO_OFF = '老師已關監視器'

    /**
     * =================================================
     * 用户状态
     * =================================================
     */

    exports.USER_OUT = 'ta已離開教室'

    exports.USER_AUDIO_ON = '已開麥克風'

    exports.USER_AUDIO_OFF = '已關麥克風'

    exports.USER_VIDEO_ON = '已開監視器'

    exports.USER_VIDEO_OFF = '已關監視器'

    /**
     * =================================================
     * 自己状态
     * =================================================
     */

    exports.SELF_AUDIO_ON = '已開麥克風'

    exports.SELF_AUDIO_OFF = '已關麥克風'

    exports.SELF_VIDEO_ON = '已開監視器'

    exports.SELF_VIDEO_OFF = '已關監視器'

    /**
     * =================================================
     * 画质
     * =================================================
     */

    exports.VIDEO_QUALITY_LOW = '流暢'

    exports.VIDEO_QUALITY_MEDIUM = '清晰'

    exports.VIDEO_QUALITY_HIGH = '高清'

    exports.VIDEO_QUALITY_SUPER = '超清'

    exports.VIDEO_QUALITY_720p = '720p'

    exports.VIDEO_QUALITY_1080p = '1080p'

    /**
     * =================================================
     * 百家云终端类型
     * =================================================
     */

    exports.END_TYPE_PC_BROWSER_BJY = '電腦網頁版'

    exports.END_TYPE_PC_CLIENT_BJY = 'pc用戶端'

    exports.END_TYPE_MAC_CLIENT_BJY = 'mac用戶端'

    exports.END_TYPE_MOBILE_BROWSER_BJY = '手機網頁版'

    exports.END_TYPE_MOBILE_XIAOCHENGXU = '微信小程式'

    exports.END_TYPE_MOBILE_APPLE_BJY = '蘋果app'

    exports.END_TYPE_MOBILE_ANDROID_BJY = '安卓app'

    exports.END_TYPE_MINI_PROGRAM_BJY = '小程式'

    exports.END_TYPE_WEBRTC_BJY = '可上麥'

    exports.END_TYPE_UNKNOWN_BJY = '未知'

    /**
     * =================================================
     * 音视频链路状态
     * =================================================
     */

    exports.AV_PLAY_STATUS_CONNECTING = '與對方建立連接中…'

    exports.AV_PLAY_STATUS_FAIL = '建立連接失敗'

    exports.AV_PLAY_STATUS_BUFFERING = '正在緩衝數據…'

    /**
     * =================================================
     * 快捷键
     * =================================================
     */

    exports.SHORTCUT_EXIT_FULLSCREEN = '退出全屏可按esc鍵'

    /**
     * =================================================
     * 按钮
     * =================================================
     */

    exports.BUTTON_SUBMIT = '確定'

    exports.BUTTON_CLOSE = '關閉'

    exports.BUTTON_CANCEL = '取消'

    exports.BUTTON_ACCEPT = '同意'

    exports.BUTTON_REJECT = '拒絕'

    exports.BUTTON_REFRESH = '重繪'

    exports.BUTTON_TRY_REFRESH = '重繪重試'

    exports.BUTTON_CLOSE_ROOM = '停播'

    exports.BUTTON_REENTER = '重新進入教室'

    exports.BUTTON_LEAVE = '退出教室'

    exports.BUTTON_START_CLASS = '上課'

    exports.BUTTON_START_CLASS_FOR_SELL = '開播'

    exports.BUTTON_END_CLASS = '下課'

    exports.BUTTON_END_CLASS_FOR_SELL = '下播'

    exports.BUTTON_LEAVE_CLASS_AND_REMOVE_ALL = '離開並移出學生'

    exports.BUTTON_END_CLASS_AND_REMOVE_ALL = '下課並移出學生'

    exports.BUTTON_STOP_RTMP_PUSH = '禁播'

    exports.BUTTON_PLAY_MEDIA = '播放'

    exports.BUTTON_RECORD_CLASS = '錄課'

    exports.BUTTON_START_RECORD_CLASS = '開始'

    exports.BUTTON_STOP_RECORD_CLASS = '停錄'

    exports.BUTTON_RESTART_RECORD_CLASS = '續錄'

    exports.BUTTON_RECORD_FULLSCREEN = '全屏錄課'

    exports.BUTTON_RECORD_AREA = '區域錄課'

    exports.BUTTON_START_SCREEN_SHARE = '荧幕分享'

    exports.BUTTON_QUESTION_ANSWER = '問答'

    exports.BUTTON_EXAM = '隨堂考'
    exports.BUTTON_END_EXAM = '結束隨堂考'

    exports.BUTTON_STOP_SCREEN_SHARE = '結束'

    exports.BUTTON_RECORD_SETTINGS = '錄課設定'

    exports.BUTTON_THIRD_PUSH = '推流服務'

    exports.BUTTON_FORBID_MIC = '禁音'

    exports.BUTTON_CANCEL_FORBID_MIC = '取消禁音'

    exports.BUTTON_SURVEY = '測驗'

    exports.BUTTON_LOTTERY = '抽獎'

    exports.BUTTON_ANSWER = '答題器'

    exports.BUTTON_DEBUG = '調試'

    exports.BUTTON_TIMER = '計時器'

    exports.BUTTON_RED_PACKET = '紅包雨'

    exports.BUTTON_ENTER_FULLSCREEN = '全屏'

    exports.BUTTON_EXIT_FULLSCREEN = '退出全屏'

    exports.BUTTON_OPEN_CAMERA = '未開啟'

    exports.BUTTON_CLOSE_CAMERA = '已開啟'

    exports.BUTTON_OPEN_MIC = '未開啟'

    exports.BUTTON_CLOSE_MIC = '已開啟'

    exports.BUTTON_SPEAK_APPLY = '舉手'

    exports.BUTTON_SPEAK_APPLY_CANCEL = '取消'

    exports.BUTTON_END_SPEAK = '結束'

    exports.BUTTON_MANAGE_DOCUMENT = '我的課件'

    exports.BUTTON_ADD_DOCUMENT = '添加'

    exports.BUTTON_REMOVE_DOCUMENT = '移除'

    exports.BUTTON_DELETE_DOCUMENT = '删除'

    exports.BUTTON_SUBMIT_DOCUMENT = '確認選擇'

    exports.BUTTON_ADD_DOCUMENT_FORM_NETDESK = '資料庫選擇'

    exports.BUTTON_UPLOAD_DOCUMENT = '普通課件'

    exports.BUTTON_SEND_MESSAGE = '發送'

    exports.BUTTON_GIFT = '送飲料'

    exports.BUTTON_EDIT_NOTICE = '編輯公告'

    exports.BUTTON_SAVE_NOTICE = '保存公告'

    exports.BUTTON_SWITCH_GIFT = '換一杯'

    exports.BUTTON_SEND_GIFT_TO_TEACHER = '送給老師'

    exports.BUTTON_FORBID_USER_SEND_MESSAGE = '禁止ta聊天'

    exports.BUTTON_UNFORBID_USER_SEND_MESSAGE = '取消對ta的禁言'

    exports.BUTTON_SURVEY_ADD_OPTION = '新增選項'

    exports.BUTTON_NEED = '需要'

    exports.BUTTON_NO_NEED = '不需要'

    exports.BUTTON_REPLY_SUBMIT = '確認答案'

    exports.BUTTON_MINIMIZE = '最小化'

    exports.BUTTON_HELP = '求助'

    exports.BUTTON_ASSISTANT_LINK = '助教連結'

    exports.BUTTON_JOIN_USERLIST = '到課名單'

    exports.BUTTON_ATTENTION_DETECTION = '專注度檢測'

    exports.BUTTON_GEN_LINK = '生成連結'

    exports.BUTTON_COPY_LINK = '複製'

    exports.BUTTON_COPY_LINK_SUCC = '成功'

    exports.BUTTON_COMMENT = '評估'

    exports.BUTTON_DETECT = '檢測'

    exports.BUTTON_MORE = '更多'

    exports.BUTTON_NEXT_STEP = '下一步'

    exports.BUTTON_COMPLETE = '完成'

    exports.BUTTON_COMMENT_SUBMIT = '提交評論'

    exports.BUTTOM_COMMENT_SEND = '評估老師'

    exports.BUTTON_COMMENT_CANCEL = '我不評估'

    exports.BUTTON_SHOW_LOGS = '展開日誌'

    exports.BUTTON_HIDE_LOGS = '收起日誌'

    exports.BUTTON_RETURN = '返回'

    exports.BUTTON_SERVER_ROUTE = '線路'

    exports.BUTTON_SERVER_SUGGEST = '首選線路'

    exports.BUTTON_SERVER_BACKUP = '備選線路'

    exports.BUTTON_SWITCH_TO_ONLINE = '顯身'

    exports.BUTTON_SWITCH_TO_OFFLINE = '隱身'

    exports.BUTTON_MODIFY = '更改'

    exports.BUTTON_UNFORBID_ALL = '取消禁言'

    exports.BUTTON_COMMENT_REQ_MORE = '查看更多'

    exports.BUTTON_COMMENT_NO_MORE = '到底啦'

    exports.BUTTON_UPGRADE_CLIENT = '陞級新版'

    exports.BUTTON_USE_GUIDE = '用戶端使用教程'

    exports.BUTTON_SWITCH_OPEN = '開'

    exports.BUTTON_SWITCH_CLOSE = '關'

    exports.BUTTON_ONLY_SHOW_MESSAGE_ABOUT_ME = '只看我'

    exports.BUTTON_ONLY_SHOW_MESSAGE_ABOUT_TEACHER = '只看老師'

    exports.BUTTON_ONLY_SHOW_MESSAGE_ABOUT_ALL = '全部'

    exports.BUTTON_SETTING_MORE_DETAIL = '更多設定'

    exports.BUTTON_BARRAGE_ON = '彈幕開'

    exports.BUTTON_BARRAGE_OFF = '彈幕關'

    exports.BUTTON_SYSTEM_SOUND = '系統聲音'

    exports.BUTTON_SWITCH_LAYOUT = '切換佈局'

    exports.BUTTON_FORBID_RAISE_HAND_OFF = '允許舉手'

    exports.BUTTON_FORBID_RAISE_HAND_ON = '禁止舉手'

    exports.BUTTON_FORBID_STUDENT_RAISE_HAND_OFF = '允許學生舉手'

    exports.BUTTON_FORBID_STUDENT_RAISE_HAND_ON = '禁止學生舉手'

    exports.BUTTON_SELL_PRODUCT = '商品'

    exports.BUTTON_SHOP = '購物車'

    exports.BUTTON_SELL_VIDEO_LAYOUT = '純視頻模板'

    exports.BUTTON_SELL_PPT_LAYOUT = 'PPT帶貨模板'

    exports.BUTTON_HOMEWORK = '工作區'

    exports.BUTTON_CONFIRM_CANCEL_SCREEN_SHARE_BITRATE_CHANGE = '暫不處理'

    exports.BUTTON_CONFIRM_OK_SCREEN_SHARE_BITRATE_CHANGE = '重新共亯'

    exports.BUTTON_TOGGLE_VIDEO_AND_DOC = '切換視窗'

    exports.BUTTON_MAIN_SCREEN_NOTICE = '主屏區公告'

    exports.BUTTON_ASSISTANT_OPTIONS = '助教操作'

    exports.BUTTON_USER_AUTH_INFO = '查看許可權'

    exports.BUTTON_REPORT = '舉報'

    exports.BUTTON_REWARD_RANKING = '獎勵排行'

    exports.BUTTON_RUSH_TO_ANSWER = '搶答器'

    exports.BUTTON_TRANSFER_CLASS_START = '開始轉播'

    exports.BUTTON_TRANSFER_CLASS_END = '結束轉播'

    exports.BUTTON_GIFT_ANIMATION = '禮物特效'

    exports.BUTTON_HIDE_GIFT_ANIMATION = '遮罩特效'

    exports.BUTTON_SHOW_GIFT_ANIMATION = '顯示特效'

    exports.BUTTON_REWARDS = '打赏'

    exports.BUTTON_REWARDS_STATISTICS = '收益統計'

    exports.BUTTON_LUCKY_BAG = '优惠券'

    exports.BUTTON_CASH_WITHDRAW = '提現'

    exports.BUTTON_VIDEO_LAYOUT = '自定義推流'

    exports.BUTTON_ON_OFF_STAGE = '輪流上臺'

    exports.BUTTON_ACTIVITY = '活動'

    exports.BUTTON_MESSAGE_CHECK = '聊天审核'

    exports.BUTTON_TURN_OFF_ALL_USERS = '全體關麥'

    /**
     * =================================================
     * 标签
     * =================================================
     */

    exports.TAB_ALL_USER_LIST = '用戶'

    exports.TAB_ACTIVE_USER_LIST = '發言清單'

    exports.TAB_CHAT = '聊天'

    exports.TAB_ANSWER_LIST = '問答'

    exports.TAB_RESEARCH_GROUP = '教研群'

    exports.TAB_USER_LIST_HIDE = '人'

    exports.TAB_CLASS_STARTED = '直播中'

    exports.TAB_TIME_SORT = '時間排序'

    exports.ANSWER_SORT_TYPE_SUBMIT = '按提交時間排序'

    exports.ANSWER_SORT_TYPE_OPERATE = '按操作時間排序'

    /**
     * =================================================
     * 普通提示
     * =================================================
     */

    exports.INFO_CLASS_START = '上課啦'

    exports.INFO_CLASS_END = '下課啦'

    exports.INFO_SPEAK_APPLY_TIMEOUT = '老師長時間未應答，已自動取消舉手'

    exports.INFO_SPEAK_INVITE_TIMEOUT = '${userName}長時間未應答或使用老版用戶端，已自動取消邀請'

    exports.INFO_SPEAK_OPEN_TIMEOUT = '${userName}長時間未應答或使用老版用戶端，已自動取消打開發言'

    exports.INFO_SPEAK_OPEN_SUCCESS = '已打開${userName}發言，可到“發言清單”查看'

    exports.INFO_HAS_BEEN_OPENED_SPEAKING = '老師已安排你語音發言'

    exports.INFO_HAS_BEEN_OPENED_WEBMIC = '老師已開啟你的麥克風'

    exports.INFO_HAS_BEEN_CLOSED_WEBMIC = '老師已關閉你的麥克風'

    exports.INFO_HAS_BEEN_OPENED_WEBCAM = '老師已開啟你的監視器'

    exports.INFO_HAS_BEEN_CLOSED_WEBCAM = '老師已關閉你的監視器'

    exports.INFO_OPEN_WEBCAM_FAILED = '視頻開啟失敗，點擊按鈕重試'

    exports.INFO_WEAR_EARPHONE_WHEN_SPEAKING = '為避免回聲和嘯叫，請佩戴耳機'

    exports.INFO_RECEIVE_MESSAGE = '你有新消息'

    exports.INFO_SPEAK_INVITE_ACCEPT = '${userName}已同意發言'

    exports.INFO_SPEAK_INVITE_REJECT = '${userName}已拒絕發言'

    exports.INFO_SPEAK_APPLY_ACCEPT = '老師允許了你發言'

    exports.INFO_SPEAK_APPLY_REJECT = '老師未同意您的舉手，請稍後再試…'

    exports.INFO_END_SPEAK_BY_TEACHER = '老師結束了你的發言'

    exports.INFO_DEVICE_IS_STARTING = '音視頻設備正在啟動中，請稍候'

    exports.INFO_CAN_NOT_DO_BEFORE_END_SETTINGS = '完成設定之前你無法進行該操作'

    exports.INFO_CAN_NOT_DO_BEFORE_START_CLASS_FOR_TEACHER = '請先點擊上課按鈕'

    exports.INFO_CAN_NOT_OPEN_CAMERA_AND_MIC = '老師不允許開啟監視器和麥克風'

    exports.INFO_CAN_NOT_DO_BEFORE_START_CLASS_FOR_STUDENT = '課程未開始'

    exports.INFO_CAN_NOT_DO_BEFORE_APPLY = '發言請先舉手'

    exports.INFO_NO_AVAILABLE_CAMERA = '沒有可用的監視器'

    exports.INFO_NO_AVAILABLE_MIC = '沒有可用的麥克風'

    exports.INFO_FORBID_SEND_MESSAGE_TO_OPERATOR = '已禁止ta聊天'

    exports.INFO_UNFORBID_SEND_MESSAGE_TO_OPERATOR = '已解除對ta的禁言'

    exports.INFO_FORBID_SEND_MESSAGE_TO_TARGET = '老師禁止了你聊天'

    exports.INFO_FORBID_SEND_MESSAGE_END = '老師已解除你的禁言'

    exports.INFO_CLIENT_AUTO_UPGRADE = '你的用戶端版本過舊，正在自動升級中…'

    exports.INFO_CLIENT_NOT_SUPPORT = '不支持的終端類型，請使用最新版本的用戶端進行觀看'

    exports.INFO_SURVEY_REPLY_RIGHT = '恭喜你，答對啦！！！'

    exports.INFO_SURVEY_REPLY_WRONG = '哎呀，答錯啦…'

    exports.INFO_SURVEY_REPLY_FREE = '本題未設定答案'

    exports.INFO_SURVEY_NO_QUESTION = '“沒有題幹，可能老師是口述的”'

    exports.INFO_SURVEY_OPTION_HINT = '點擊編輯選項'

    exports.INFO_SURVEY_CHOOSE_OPTION = '<span class="arrow">↙</span>打勾選擇正確答案'

    exports.INFO_SURVEY_SELF_CHOOSE = '你的選擇：'

    exports.INFO_COMMENT_SUCC = '評估成功'

    exports.INFO_COMMENT_BEFORE_CLASS = '請稍候評估'

    exports.INFO_APPLY_SPEAK_WOULD_DELAY_SOUND = '使用網頁版本發言可能會有聲音延遲'

    exports.INFO_SPEAK_INVITE_DENY = '發言人數已滿，請稍後重試'

    exports.INFO_MEDIA_PUBLISH_DENY = '發言人數已滿，請稍後重試'

    exports.INFO_CAN_NOT_CLOSE_CAMERA = '當前線路不提供關閉視頻功能'

    // exports.INFO_SWITCH_SERVER_SUCCESS = '已切换至 ${0}';

    exports.INFO_SWITCH_SERVER_SUCCESS = '已切換'

    exports.INFO_FORBID_ALL = '已全體禁言'

    exports.INFO_UNFORBID_ALL = '已解除全體禁言'

    exports.INFO_FORBID_GROUP_ALL = '本組已全體禁言'

    exports.INFO_UNFORBID_GROUP_ALL = '本組已取消全體禁言'

    exports.INFO_SELF_ABROAD_TIPS
        = '檢測到您在國外上課，跨國網絡的穩定情况可能無法得到保證。<br/>' + '請您複查確保您對中國國內的存取速度正常。'

    exports.INFO_TEACHER_ABROAD_TIPS
        = '發現老師在國外上課，由於國外網絡的複雜情况，<br/>' + '聲音視頻可能會出現不穩定的問題，請諒解。'

    exports.INFO_OPEN_CAMERA = '${userRole}開啟監視器，數據正在緩衝'

    exports.INFO_OPEN_ASSIST_CAMERA = '${userRole}開啟輔助監視器，數據正在緩衝'

    exports.INFO_CLOSE_CAMERA = '關閉監視器'

    exports.INFO_OPEN_MIC = '${userRole}開啟麥克風，數據正在緩衝'

    exports.INFO_CLOSE_MIC = '關閉麥克風'

    exports.INFO_CAN_NOT_CHANGE_LINK_TYPE_SHARE_PLAY = '請先關閉荧幕分享和播放機，停止轉發協力廠商流'

    exports.INFO_CAN_NOT_CHANGE_LINK_TYPE_CLOUD_RECORD = '雲端錄課中不可切換上行連結類型'

    exports.INFO_CAN_NOT_OPEN_BEAUTIFY_DENOISE = '高清、超清、1080p模式下無法開啟美顏'

    exports.INFO_CAN_NOT_OPEN_BEAUTIFY_DENOISE = '高清、超清、720p、1080p模式下無法開啟美顏'

    exports.INFO_CLOUD_RECORD_START = '已開啟雲端錄製'

    exports.INFO_CLOUD_RECORD_STOP = '已經停止雲端錄製'

    exports.INFO_CAN_NOT_SCREEN_SHARE_BEFORE_CLOSE_THIRD_PUSH = '分享荧幕前，請先停止轉發協力廠商推流'

    exports.INFO_CAN_NOT_SCREEN_SHARE_BEFORE_CLOSE_PLAY_FILE = '分享荧幕前，請先停止檔案播放'

    exports.INFO_CAN_NOT_PLAY_FILE_BEFORE_CLOSE_SCREEN_SHARE = '播放檔案前，請先停止荧幕分享'

    exports.CONFIRM_STOP_ASSIST_CAMERA_BEFORE_MEDIA_PLAY = '<b>是否開啟媒體播放？</b>開啟媒體播放將關閉輔助監視器。'

    exports.CONFIRM_STOP_MEDIA_PLAY_BEFORE_OPEN_ASSIST_CAMERA
        = '<b>是否開啟輔助監視器？</b>開啟輔助監視器將關閉媒體播放。'

    exports.INFO_PLAY_LOCAL_MEDIA_FILE = '播放本地檔案'

    exports.INFO_CAN_NOT_PLAY_LOCAL_MEDIA_FILE_BEFORE_CLOSE_THIRD_PUSH = '播放本地檔案前，請先停止轉發協力廠商推流'

    exports.INFO_CAN_NOT_THIRD_PUSH_BEFORE_CLOSE_SCREEN_SHARE = '轉發協力廠商推流前，請先停止荧幕分享'

    exports.INFO_CAN_NOT_PLAY_LOCAL_MEDIA_FILE_WHEN_COLLECT_SYSTEM_SOUND = '開始採集系統聲音後將不能播放本地檔案'

    exports.INFO_CAN_NOT_PLAY_LOCAL_MEDIA_FILE_BEFORE_CLOSE_COLLECT_SYSTEM_SOUND = '請先取消採集系統聲音'

    exports.INFO_CAN_NOT_COLLECT_SYSTEM_SOUND_BEFORE_CLOSE_PLAY_LOCAL_MEDIA_FILE = '請先關閉本地檔案播放'

    exports.INFO_CAN_NOT_COLLECT_SYSTEM_SOUND_BEFORE_CLOSE_MEDIA_FILE_PLAY = '開始播放本地檔案後將不能採集系統聲音'

    exports.INFO_CAN_NOT_THIRD_PUSH_BEFORE_CLOSE_SHARE_DESKTOP = '轉發協力廠商推流前，請先停止荧幕分享'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START = '正在生成重播，本課節無法繼續使用雲端錄製'

    exports.INFO_CLOUD_RECORD_START_COUNT_WARNING = '頻繁點擊暫停/停止可能會影響回放品質，請稍後再點擊'

    exports.INFO_GET_PLAYBACK_STATUS_FAIL = '獲取重播生成狀態失敗，請重試'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START_TIP
        = '<p class="large">您是否希望現在開始生成重播？</p> <p class="error">（開始生成重播後，本課節後續將無法使用雲端錄製）</p>'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START_TIP_LONG_TERM = '<p class="large">您是否希望現在開始生成重播？</p>'

    exports.INFO_SEND_IMAGE_POST_DATA_ERROR = '數據解析錯誤'

    exports.INFO_CAN_NOT_DETECT_DEVICE_DURING_SPEAKING = '系統檢測前請先終止發言'

    exports.INFO_CAN_NOT_CHANGE_LINK_TYPE_CONSISTENSY = '連結類型已被統一配寘，此設定將不生效'

    exports.INFO_CLOSE_BARRAGE_TIP = '如需使用畫筆請先關閉彈幕功能'

    exports.INFO_SETTING_FORBID_BY_CLASS_STARTED = '上課過程中無法更改此項設定'

    exports.INFO_RTMP_NOT_RUNNING = '老師未推流'

    exports.INFO_HAS_FORBID_MIC = '已經關閉所有人麥克風'

    exports.INFO_HAS_BEEN_MUTED = '老師關閉了所有人麥克風'

    exports.INFO_MESSAGE_COPY_SUCCESS = '聊天內容複製成功'

    exports.INFO_QA_COPY_SUCCESS = '問答內容複製成功'

    exports.INFO_QA_COPY_FAIL = '問答內容複製失敗，請手動複製'

    exports.INFO_PLAYER_PAUSE_BY_MIC_OFF = '如需繼續播放檔案，請打開您的麥克風'

    exports.INFO_USER_ACTIVE_ADD_DENY = '發言人數已滿，請先關閉其他同學的音視頻。'

    exports.INFO_ENROLL_START = '已發起報名'

    exports.CLASSROOM_COUNTDOWN_TITLE = '距直播開始還有'

    exports.INFO_GIFT_ANIMATION_ENABLE = '禮物特效已開啟'

    exports.INFO_GIFT_ANIMATION_DISABLE = '禮物特效已關閉'

    exports.INFO_NO_CAMERA_OPERATION_PERMISSION = '暫無攝像頭操作許可權'

    /**
     * =================================================
     * 空状态提示
     * =================================================
     */
    exports.INFO_NO_SPEAKER = '沒有其他人發言'

    /**
     * =================================================
     * 警告提示
     * =================================================
     */

    exports.WARNING_INPUT_FREQUENT = '請不要刷屏哦'

    exports.WARNING_INPUT_EMPTY = '請輸入聊天內容哦'

    exports.WARNING_INPUT_OVERLENGTH = '請不要輸入太長的內容哦'

    exports.WARNING_CAMERA_SWITCH_FREQUENT = '請不要頻繁開關監視器'

    exports.WARNING_MIC_SWITCH_FREQUENT = '請不要頻繁開關麥克風'

    exports.WARNING_CLOSE_DIALOG_ON_DOCUMENT_UPLOADING = '課件正在上傳中，請耐心等待'

    exports.WARNING_SEND_MESSAGE_FORBID = '你已被禁止聊天'

    exports.WARNING_SURVEY_OPTION_HINT = '點擊序號字母，設定正確答案'

    exports.WARNING_SURVEY_TEXTAREA_MAX = '題幹請不要多於100個字！'

    exports.WARNING_SURVEY_OPTION_MAX = '選項請不要多於25個字！'

    exports.WARNING_VOLUME_OVERFLOW = '放大過度，可能失真哦'

    exports.WARNING_COMMENT_TEXT_HINT = '還可以輸入'

    exports.WARNING_COMMENT_TEXT_UNIT = '字'

    exports.WARING_COMMENT_NO_TEXT = '請輸入對老師的評估'

    exports.WARING_COMMENT_NO_CONTENT = '請輸入老師的總體評價'

    exports.WARING_COMMENT_UPLOAD_FULL = '最多添加五張圖片'

    exports.WARNING_SWITCH_CDN_SERVER = '老師切換線路會導致所有學生自動重進教室，確定切換嗎？'

    exports.WARNING_ABROAD_CONFIRM = '知道了'

    exports.WARNING_ABRAOD_TIPS = '提醒'

    exports.WARING_PLAY_FILE_FAILED = '播放檔案失敗，不支持的檔案類型或視頻已移除'

    exports.WARING_PLAY_FILE_LENGTH_FAILED = '請上傳至少大於1s的音/視頻檔案！'

    exports.WARN_WEBRTC_MEDIA_DEVICE_PERMISSON_DENY = '${authType}啟動失敗，請允許我們獲取${deviceType}的使用許可權'

    exports.WARN_NO_AUTH_QUIZ = '您被禁用測驗許可權'

    exports.WARN_NO_AUTH_ANSWER = '您被禁用答題器許可權'

    exports.RISK_ASSESSMENT = '風險測評'

    /**
     * =================================================
     * 成功提示
     * =================================================
     */

    exports.SUCCESS_UPLOAD_DOCUMENT = '上傳成功，轉碼中請稍後'

    exports.SUCCESS_DETECT_CAMERA = '成功檢測到監視器設備'

    exports.SUCCESS_DETECT_ASSIST_CAMERA = '成功檢測到輔助監視器設備'

    exports.FAIL_DETECT_ASSIST_CAMERA = '未檢測到輔助監視器設備'

    /**
     * =================================================
     * 错误提示
     * =================================================
     */

    exports.ERROR_RECORD_FAIL_ON_PATH_NOT_EXIST = '不存在，課程錄製無法繼續'

    exports.ERROR_RECORD_FAIL_ON_DISK_NOT_ENOUGH = '磁碟空間不足，課程錄製無法繼續'

    exports.ERROR_UPLOAD_DOCUMENT = '上傳失敗'

    exports.ERROR_DOCUMENT_TYPE_NOT_SUPPORT = '檔案格式錯誤，請上傳word、ppt、pdf或圖片格式的課件'

    exports.ERROR_DOCUMENT_SIZE_NOT_SUPPORT = '請上傳文件小於50m的檔案'

    exports.ERROR_DOCUMENT_NAME = '檔名包含標點符號，請修改檔名再上傳'

    exports.ERROR_GET_GIFT_PAY_URL = '額，配送失敗了，重新試一下……'

    exports.ERROR_RUN_CEF_FAIL = '用戶端初始化失敗，請重啓用戶端'

    exports.ERROR_NOT_SURPORT_SELL_TEMPLATE = 'pc不支持，請通過h5進入'

    /**
     * =================================================
     * 邀请函
     * =================================================
     */

    exports.ENTER_CLASSROOM_BY_JOIN_CODE = '參加碼管道'

    exports.ENTER_CLASSROOM_WITH_SECRET = 'app密令管道'

    exports.JOIN_CODE = '參加碼'

    exports.JOIN_CODE_SPECIFICATION = '參加碼使用說明'

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_DAYS = '天 '

    // 为了使倒计时的时间数字和量词之间不会挨在一起，要在‘时’和‘分’后加一个空格
    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_HOURS = '時 '

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_MINUTES = '分 '

    exports.CLASSROOM_ENTER_COUNTDOWN_CHAR_SECONDS = '秒'

    exports.CLASSROOM_ENTER_CONFIRM_DIALOG_TITLE = '提示'

    exports.CLASS_START_TIME = '開始時間'

    exports.TEACH_DURATION = '授課時長'

    exports.CLASSROOM_ENTER_CONFIRM_DIALOG_LABEL = '請輸入您的真實姓名：'

    exports.CLASSROOM_ENTER_CONFIRM_DIALOG_TIP = '輸入不能為空'

    exports.INVITATION_TITILE_HINT = '提示'

    exports.INVITATION_TIP_OPENING_CLIENT = '正在嘗試打開用戶端……'

    exports.INVITATION_BUTTON_DOWNLOAD_CLIENT = '下載用戶端'

    exports.INVITATION_BUTTON_ENTER_CLASSROOM_VIA_WEB = '網頁進教室'

    exports.INVITATION_LABEL_OTHER_METHOD_ENTER_CLASSROOM = '其它進教室管道'

    exports.INVITATION_TIP_ADVICE_DOWNLOAD_CLIENT
        = '如果未安裝或不能打開用戶端，請下載最新用戶端，用戶端觀看直播更流暢，功能更强大'

    /**
     * =================================================
     * 倒计时
     * =================================================
     */

    exports.CLASSROOM_ENTER_COUNT_DOWN_TIP = '額..開始前${preEnterTimeText}才能進房間'

    exports.CLASS_EXPIRE_TIP = '額..該直播已結束啦'

    exports.CLASS_DELETED_TIP = '額..該直播已取消啦'

    exports.CLASSROOM_ENTER_TIP_STRING_DAYS = '天'

    exports.CLASSROOM_ENTER_TIP_STRING_HOURS = '小時'

    exports.CLASSROOM_ENTER_TIP_STRING_MINUTES = '分鐘'

    exports.CLASSROOM_ENTER_TIP_STRING_SECONDS = '秒'

    exports.BUTTON_ENTER = '進入直播間'

    /**
     * =================================================
     * 试听课
     * =================================================
     */
    exports.TRIAL_START_TIP = '試聽${leftMinutes}分鐘，觀看完整直播請<span class="enroll">立即報名</span>吧'

    exports.TRIAL_END_TIP = '該課程的試聽即將結束，覺得老師講的不錯就<span class="enroll">立即報名</span>吧'

    exports.COURSE_ENROLL_HREF = '立即報名'

    exports.FORBIDDEN_BTN_TIP = '報名後才能與老師互動哦'

    exports.TRIAL_LEAVE_NOTICE = '確定離開試聽課教室嗎？'

    /**
     * =================================================
     * 确认
     * =================================================
     */

    exports.CONFIRM_END_CLASS = '確認要下課嗎？'

    exports.CONFIRM_END_SPEAK = '確認要結束發言嗎？'

    exports.CONFIRM_END_WARMING_UP = '確定結束暖場嗎？'

    exports.CONFIRM_STOP_RECORD = '確認要停止錄製課程嗎？'

    exports.CONFIRM_STOP_SCREEN_SHARE = '確認要停止共亯案頭嗎？'

    exports.CONFIRM_SWITCH_LINK_TYPE = '您的網絡不太穩定，是否嘗試切換連結類型解决？'

    exports.CONFIRM_STOP_SCREEN_SHARE_ON_CLOSE_CAMERA = '關閉監視器將停止共亯案頭，確認關閉嗎？'

    exports.CONFIRM_STOP_SCREEN_SHARE_ON_OPEN_CAMERA = '打開監視器將停止共亯案頭，確認打開嗎？'

    exports.CONFIRM_RELOAD_ON_WEBSOCKET_CLOSE_BJY = '你好像斷網了，快檢查一下網絡，重連試試？'

    exports.CONFIRM_PUBLISH_VIDEO_BEFORE_SCREEN_SHARE = '共亯案頭必須先打開監視器，需要打開嗎？'

    exports.CONFIRM_PUBLISH_VIDEO_BEFORE_PLAY_MEDIA = '播放本地音視頻檔案必須先打開監視器，需要打開嗎？'

    exports.CONFIRM_UPGRADE_BEFORE_USE = '您當前的用戶端版本較低，無法正常接收老師的聲音視頻，請陞級最新用戶端。'

    exports.CONFIRM_UPGRADE_HINT = '您當前的用戶端版本過低，請點擊更新按鈕下載最新用戶端，<br />體驗更豐富的功能'

    exports.CONFIRM_EXIT_CLASSROOM = '是否離開直播間？'

    exports.CONFIRM_EXIT_CLASSROOM_IN_CLASS = '上課中離開教室將自動下課，您確定嗎？'

    exports.CONFIRM_EXIT_CLASSROOM_IN_CLOUD_RECORD = '課程錄製中，離開教室將自動下課並停止雲端錄製'

    exports.CONFIRM_USE_CAMERA_ON_NO_AVAILABLE_CAMERA = '沒有檢測到可用的監視器，你需要使用監視器嗎？'

    exports.CONFIRM_USE_MIC_ON_NO_AVAILABLE_MIC = '沒有檢測到可用的麥克風，你需要使用麥克風嗎？'

    exports.CONFRIM_FORBID_USER_SEND_MESSAGE = '確認要禁止ta聊天嗎？'

    exports.CONFIRM_REMOVE_DOCUMENT = '確認要删除該課件嗎？'

    exports.CONFIRM_REMOVE_HOMEWORK = '確認要删除工作嗎？'

    exports.CONFIRM_RELOAD_PLAYER_ON_NO_AVAILABLE_CAMERA = '未檢測到可用的監視器設備，是否重新檢測？'

    exports.CONFIRM_RELOAD_PLAYER_ON_NO_AVAILABLE_ASSIST_CAMERA = '未檢測到可用的輔助監視器設備，是否重新檢測？'

    exports.CONFIRM_PURCHASE = '你還未報名課程，先報個名？'

    exports.CONFIRM_TO_TCP_LINK = '切換tcp上行會導致學生聲音無法錄製，確認切換嗎？'

    exports.CONFIRM_END_RTMP_PUSH = '確認要終止老師的推流嗎？'

    exports.CONFIRM_SCREEN_SHARE_BITRATE_CHANGE = '直播間荧幕分享碼率已變更，請點擊重新共亯後生效'

    exports.CONFIRM_CONNECT_HAND_WRITTING_BOARD_TITLE = '連接手寫板'

    exports.CONFIRM_CONNECT_HAND_WRITTING_BOARD_CONTENT
        = '手寫板連接失敗，請重新連接<br>請確認“外接手寫板”已打開且在通信範圍內'

    exports.CONFIRM_BUTTON_CONNECT_HAND_WRITTING_BOARD = '重新連接'

    exports.CONFIRM_PIP_ERR = '初始化中，請點擊“確定”生效“露臉”功能'

    exports.CONFIRM_TURN_OFF_ALL_USERS = '確認要關閉所有人的麥克風嗎？'

    /**
     * =================================================
     * Tooltip
     * =================================================
     */

    exports.TOOLTIP_LASER = '鐳射筆'

    exports.TOOLTIP_MOVE = '移動'

    exports.TOOLTIP_DOODLE = '畫筆'

    exports.TOOLTIP_TEXT = '文字'

    exports.TOOLTIP_ARROW = '箭頭'

    exports.TOOLTIP_RECT = '矩形'

    exports.TOOLTIP_ERASER = '清除'

    exports.TOOLTIP_CLEAR = '清空'

    exports.TOOLTIP_SMILE = '微笑'

    exports.TOOLTIP_GIGGLE = '憨笑'

    exports.TOOLTIP_PROUD = '得意'

    exports.TOOLTIP_NAUGHTY = '調皮'

    exports.TOOLTIP_EXHAUSTED = '好困'

    exports.TOOLTIP_CRY = '大哭'

    exports.TOOLTIP_EMBARRASSED = '撇嘴'

    exports.TOOLTIP_DOUBT = '疑問'

    exports.TOOLTIP_APPEARANCE = '色'

    exports.TOOLTIP_POWERFUL = '厲害'

    exports.TOOLTIP_WORSHIP = '崇拜'

    exports.TOOLTIP_STRUGGLE = '奮戰'

    exports.TOOLTIP_WEIGHS = '暈'

    exports.TOOLTIP_SURPRISE = '驚訝'

    exports.TOOLTIP_SPEECHLESS = '無言'

    exports.TOOLTIP_HEARTSTOPPER = '衰'

    /**
     * =================================================
     * 对话框
     * =================================================
     */

    exports.DIALOG_MANAGE_DOCUMENT = '選擇檔案'

    exports.DIALOG_MANAGE_HOMEWORK = '工作區'

    exports.DIALOG_DEBUG = '調試資訊'

    exports.USER_DIALOG_DEBUG = '課程資訊'

    exports.ALERT_DEFAULT_TITLE = '提示'

    exports.DIALOG_QUESTION_ANSWER = '問答'

    exports.DIALOG_DEBUG_PANEL = '調試面板'

    exports.DIALOG_MESSAGE_BOX_PUBLIC = '{title}-公聊'

    exports.DIALOG_MESSAGE_BOX_RESEARCH = '{title}-教研群'

    exports.DIALOG_MESSAGE_BOX_WHISPER = '{title}-正在和{user-name}私聊'

    exports.DIALOG_USER_AUTH_TITLE = '友情提示'

    exports.MORE_BUTTON_TITLE = '更多功能'

    exports.MORE_BUTTON_TITLE_EDIT = '編輯'

    exports.DIALOG_REPORT_TITLE = '請選擇舉報原因'

    /**
     * =================================================
     * 空文本占位符
     * =================================================
     */

    exports.PLACEHOLDER_NOTICE_FOR_WRITER = '可以在這裡發佈班級公告~'

    exports.PLACEHOLDER_NOTICE_GROUP_FOR_WRITER = '可以在這裡發佈組內通知~'

    exports.PLACEHOLDER_NOTICE_FOR_READER = '公告欄空空的…'

    exports.PLACEHOLDER_INPUT_AMOUNT = '請輸入金額'

    exports.PLACEHOLDER_COMMENT_FOR_SEND = '來寫一下你對老師的評估吧'

    /**
     * =================================================
     * 一些杂七杂八的话术
     * =================================================
     */

    exports.LABEL_RECORDING = '錄製'

    exports.LABEL_WECHAT_HELP = '微信求助'

    exports.LABEL_STUDENT_JOIN_CLASS_NO = '學生未進教室'

    exports.LABEL_STUDENT_JOIN_CLASS_YES = '學生已進入教室'

    exports.LABEL_FAIL_AGAIN = '仍然失敗？'

    exports.LABEL_CONTACT_TEL = '可撥打客戶電話：4000-910-910'

    exports.LABEL_CONTACT_QQ = '或添加技術支援qq:3303460898'

    exports.LABEL_CLASSROOM_ID_TEXT = '教室id'

    exports.LABEL_TOUCH_SCREEN_SUPPERT = '觸控式螢幕支持'

    exports.LABEL_VIDEO_POPUP_TO_AUX_SCREEN = '視頻彈出到輔助荧幕'

    exports.LABEL_REPAIR_PROGRAM_SHARE = '修復程式共亯黑屏'

    exports.LABEL_MEDIA_PANEL = '用戶區'

    exports.LABEL_MESSAGE_PANEL = '文字討論'

    exports.LABEL_LOADING = '正在加載…'

    exports.LABEL_DATA_LOADING = '數據加載中，請稍候…'

    exports.LABEL_VIDEO = '視頻'

    exports.LABEL_AUDIO = '音訊'

    exports.LABEL_AUDIO_AND_VIDEO = '音視頻'

    exports.LABEL_WHITEBOARD = '白板'

    exports.LABEL_CAMERA = '監視器'

    exports.LABEL_MIC = '麥克風'

    exports.LABEL_MIC_AND_CAMERA = '麥克風和監視器'

    exports.LABEL_SPEAKER = '揚聲器'

    exports.LABEL_RECORD = '課程錄製'

    exports.LABEL_SHARE = '荧幕分享'

    exports.LABEL_CLASS_SETTING = '房間控制'

    exports.LABEL_OTHER = '其它'

    exports.LABEL_DEVICE_LIST = '設備清單'

    exports.LABEL_AUDIO_REPAIR = '聲道修復'

    exports.LABEL_AUDIO_REPAIR_NO = '不需要修復'

    exports.LABEL_AUDIO_REPAIR_LEFT = '修復左聲道'

    exports.LABEL_AUDIO_REPAIR_RIGHT = '修復右聲道'

    exports.LABEL_INPUT_VOLUME = '輸入音量'

    exports.LABEL_OUTPUT_VOLUME = '輸出音量'

    exports.LABEL_AGC = '自動增益'

    exports.LABEL_POPUP = '彈出'

    exports.LABEL_CLOSE = '關閉'

    exports.LAEBL_CLOSE_MIC = '終止發言'

    exports.LABEL_PRIMARY_CAMERA_SETTING = '主監視器設定'

    exports.LABEL_MINOR_CAMERA_SETTING = '輔助監視器設定'

    exports.LABEL_NO_AVAILABLE_CAMERA = '沒有可用的監視器'

    exports.LABEL_NO_AVAILABLE_MIC = '沒有可用的麥克風'

    exports.LABEL_NO_AVAILABLE_SPEAKER = '沒有可用的揚聲器'

    exports.LABEL_VIDEO_QUALITY = '視頻質量'

    exports.LABEL_CAN_YOU_HEAR_YOUR_VOICE = '提示：請說話，是否能聽到自己的聲音？'

    exports.LABEL_APPLY_BEFORE_SPEAK = '發言請先舉手'

    exports.LABEL_WAIT_TEACHER_ACCEPT = '請等待老師同意'

    exports.LABEL_SPEAK_APPLYING = '舉手中'

    exports.LABEL_TEACHER_SPEAK_INVITING = '老師邀請你上麥發言'

    exports.LABEL_DOCUMENT_IN_LIBRARY = '資料庫'

    exports.LABEL_DOCUMENT_IN_USE = '展示課件'

    exports.LABEL_DOCUMENT_TYPE_HINT = 'wps編輯的檔案請轉換成pdf後上傳'

    exports.LABEL_DOCUMENT_HELP_LINK = '點此查看轉換教程'

    exports.LABEL_PAGE_LOADING = '課件加載中…'

    exports.LABEL_DOCUMENT_TRANSFORMING = '檔案正在努力轉換中，請稍候…'

    exports.LABEL_DOCUMENT_TRANSFORMING_TIP = '轉碼中…'

    exports.LABEL_DOCUMENT_TRANSFORM_COMPLETE_TIP = '轉碼完成'

    exports.LABEL_DOCUMENT_TRANSFORM_FAIL = '檔案轉換失敗，請重新上傳'

    exports.LABEL_CLASS_DOCUMENT = '我的課件'

    exports.lABEL_USER_DOCUMENT = '學生照片'

    exports.LABEL_UPLINK_BANDWIDTH = '上行頻寬'

    exports.LABEL_DOWNLINK_BANDWIDTH = '下行頻寬'

    exports.LABEL_FORBID_ALL_REMINDER = '營員全體禁言中'

    exports.LABEL_SEND_GIFT_PAY_TITLE = '謝謝老師，麼麼噠'

    exports.LABEL_LOADING_TIMEOUT = '進不了教室？呼叫求助4000-910-910'

    exports.LABEL_SURVEY_QUESTION = '題目：'

    exports.LABEL_SURVEY_MULTIPLE_ANSWER = '多選'

    exports.LABEL_SURVEY_SEND_TITLE = '出題'

    exports.LABEL_SURVEY_REPLY_TITLE = '答題'

    exports.LABEL_SURVEY_REPLY_RESULT = '答題結果'

    exports.LABEL_SURVEY_MYCHOICE = '你的選項'

    exports.LABEL_SURVEY_RIGHT_COUNT = '答對'

    exports.LABEL_SURVEY_WRONG_COUNT = '答錯'

    exports.LABEL_SURVEY_OPTION_UNIT = '人'

    exports.LABEL_SURVEY_TITLE_NAME = '答題卡'

    exports.LABEL_GIFT_TYPE_ORANGE_JUICE = '橙汁'

    exports.LABEL_GIFT_TYPE_ICE_TEA = '冰紅茶'

    exports.LABEL_GIFT_TYPE_BARLEY_TEA = '大麥茶'

    exports.LABEL_RECORDING_INDICATOR = '老師錄課中'

    exports.LABEL_RECORDING_LOCAL = '本地'

    exports.LABEL_RECORDING_CLOUD = '雲端'

    exports.LABEL_RECORDING_PUSH = '截圖推流'

    exports.LABEL_RECORDING_SUFFIX = '錄製中'

    exports.LABEL_DOC_QUALITY_HIGH = '原圖'

    exports.LABEL_DOC_QUALITY_LOW = '流暢'

    exports.LABEL_DOC_FIT_WIDTH = '填充'

    exports.LABEL_DOC_FIT_VIEW = '適應'

    exports.LABEL_COMMENT_REMIND_TITLE = '評估本次課程'

    exports.LABEL_COMMENT_POINT_UNIT = '分'

    exports.LABEL_COMMENT_TEACHER_TITLE = '我的評估'

    exports.LABEL_COMMENT_TYPE_TOTAL = '全部'

    exports.LABEL_COMMENT_TYPE_GREAT = '好評'

    exports.LABEL_COMMENT_TYPE_MIDDLE = '中評'

    exports.LABEL_COMMENT_TYPE_LOWER = '差評'

    exports.LABEL_COMMENT_MAX_LENGHT = '200字'

    exports.LABEL_COMMENT_TOTAL_RATER = '總體評價'

    exports.LABEL_COMMENT_ANONYMOUS = '匿名評估'

    exports.LABEL_COMMENT_REMARK = '評估'

    exports.LABEL_COMMENT_POINT_FIVE = '五星'

    exports.LABEL_COMMENT_POINT_FOUR = '四星'

    exports.LABEL_COMMENT_POINT_THREE = '三星'

    exports.LABEL_COMMENT_POINT_TWO = '二星'

    exports.LABEL_COMMENT_POINT_ONE = '一星'

    exports.LABEL_COMMENT_UNIT_TIPS = '共${totalCount}條'

    exports.LABEL_COMMENT_TYPE = '學習評估'

    exports.LABEL_BEAUTIFY_AND_DENOISE = '美顏降噪'

    exports.LABEL_SETTINGS = '設定'

    exports.LABEL_AUTH_MANAGEMENT = '許可權管理'

    exports.LABEL_EYE_PROTECTION = '護眼模式'

    exports.LABEL_SCREENSHOT = '截圖'

    exports.LABEL_SCREENSHOT_WITH_ROOM_HIDED = '隱藏教室截圖'

    exports.LABEL_POSITION = '位置${number}'

    exports.LABEL_DETECT_TOOL = '系統檢測'

    exports.LABEL_FORBID_ALL = '全體禁言'

    exports.LABEL_SHARE_POSITION = '荧幕分享影像顯示位置'

    exports.LABEL_SHARE_POSITION_MOD_TIP = '以後可到設定中更改'

    exports.LABEL_NUMBER_ONE = '一'

    exports.LABEL_NUMBER_TWO = '二'

    exports.LABEL_NUMBER_THREE = '三'

    exports.LABEL_NUMBER_FOUR = '四'

    exports.LABEL_NUMBER_FIVE = '五'

    exports.LABEL_NUMBER_SIX = '六'

    exports.LABEL_NUMBER_SEVEN = '七'

    exports.LABEL_NUMBER_EIGHT = '八'

    exports.LABEL_NUMBER_NINE = '九'

    exports.LABEL_NUMBER_TEN = '十'

    exports.LABEL_SERVER_ROUTE = '線路${number}'

    exports.LABEL_OTHER_SERVER_ROUTE = '其他線路'

    exports.LABEL_CDN_ROUTE_PRIMARY = '主'

    exports.LABEL_CDN_ROUTE_ASSISTANT = '副'

    exports.LABEL_CHECK_ALL = '全選'

    exports.LABEL_UNIT = '個'

    exports.LABEL_LINK_TYPE = '連結類型'

    exports.LABEL_UPLINK = '上行'

    exports.LABEL_DOWNLINK = '下行'

    exports.LABEL_tcp = 'tcp'

    exports.LABEL_udp = 'udp'

    exports.LABEL_TEACHER = '老師'

    exports.LABEL_NICKNAME = '昵稱'

    exports.LABEL_DON_NOT_REMIND_ANY_MORE = '下次不再提醒'

    exports.LABEL_GIFT_PAY_HINT = '支付方式'

    exports.LABEL_GIFT_WECHAT = '微信'

    exports.LABEL_GIFT_ALIPAY = '支付寶'

    exports.LABEL_COMMENT_RECEIVE_TITLE = '評估清單'

    exports.LABEL_COMMENT_SEND_TITLE = '評估本次課程'

    exports.LABEL_LOTTERY_SEND_TITLE = '發獎品'

    exports.LABEL_LOTTERY_SEND_HEADER = '"告訴同學們，這次的驚喜又是什麼"'

    exports.LABEL_LOTTERY_SEND_NAME = '獎品名稱'

    exports.LABEL_LOTTERY_SEND_NUMBER = '獎品份數'

    exports.LABEL_CURRENT_STUDENT_COUNT = '當前教室學生${userCount}人'

    exports.LABEL_LOTTERY_SEND_HINT = '抽中獎品同學可獲得兌獎碼<br/>獎品兌換請老師自行聯系學生'

    exports.LABEL_LOTTERY_DRAW_HINT = '老師將通過兌獎碼發放獎品'

    exports.LABEL_LOTTERY_SEND_BTN = '發送禮品'

    exports.LABEL_LOTTERY_UNIT = '份'

    exports.LABEL_LOTTERY_REMAIN = '還剩'

    exports.LABEL_LOTTERY_SAVE_LIST = '保存名單'

    exports.LABEL_LOTTERY_DRAW_TIP = '發了一個禮物'

    exports.LANEL_LOTTERY_DRAW_BTN = '拆紅包'

    exports.LABEL_LOTTERY_DRAW_SUCC = '恭喜！您中獎了'

    exports.LABEL_LOTTERY_DRAW_CODE = '兌獎碼'

    exports.LABEL_LOTTERY_SHOW_WINNERS = '看看大家手氣>>'

    exports.LABEL_LOTTERY_DRAW_FAIL = '手慢了，紅包派完了'

    exports.LABEL_LOTTERY_REDPACK = '紅包'

    exports.LABEL_OF_UNITE = '的'

    exports.LABEL_INPUT_LOTTERY_NAME = '請輸入獎品名稱'

    exports.LABEL_INPUT_LOTTERY_NUMBER_ERROR = '請輸入正確獎品數量'

    exports.LABEL_INPUT_LOTTERY_OVER_MEMBER = '獎品數量不能大於學生人數'

    exports.LABEL_INPUT_LOTTERY_OVER_MAX = '獎品數量不能大餘50個'

    exports.LABEL_CAMERA_PIXEL_RATIO = '視頻比例'

    exports.LABEL_CAMERA_SETTING = '視頻設定'

    exports.LABEL_CAMERA_FLIP_HORIZONTAL = '水准翻轉'

    exports.LABEL_CAMERA_FLIP_VERTICAL = '垂直翻轉'

    exports.LABEL_CAMERA_CROP = '畫面裁切'

    exports.LABEL_CAMERA_DISENABLE = '不啟用'

    exports.LABEL_TIP_CLICK_BTN_START_CLASS = '點擊按鈕開始上課'

    exports.LABEL_UPDATE_OLD_CLIENT_VERSION = '當前用戶端版本過低，請陞級到最新版'

    exports.LABEL_UPDATE_CLIENT_VERSION = '前往下載最新用戶端'

    exports.LABEL_CLOSE_CLIENT = '關閉用戶端'

    exports.LABEL_CLIENT_INVITE_CODE = '用戶端邀請碼'

    exports.LABEL_WEB_LINK = '網頁端連結'

    exports.LABEL_REFRESH_WAITED = '正在重繪，請稍後'

    exports.LABEL_SHAREING_NO_OPTION = '荧幕分享中，不支持此操作'

    exports.LABEL_WHISPER_TITLE = '私聊'

    exports.LABEL_BARRAGE = '彈幕'

    exports.LABEL_LOCK_SCREEN = '學生鎖'

    exports.LABEL_RAISE_HAND = '舉手'

    exports.LABEL_APPLY_SPEAK = '請求發言'

    exports.LABEL_SAVE_SUCCESS = '保存成功！'

    /**
     * =================================================
     * 求助
     * =================================================
     */

    exports.BUTTON_CUSTOM_SERVICE_QQ = 'qq求助'

    exports.BUTTON_CUSTOM_SERVICE_TECHNICAL = '科技求助'

    exports.BUTTON_CUSTOM_SERVICE_CLASS_INFO = '課程資訊'

    exports.DIALOG_TITLE_TECH_HELP = '科技求助'

    exports.BUTTON_CUSTOM_SERVICE_WECHAT = '微信求助'

    exports.BUTTON_CUSTOM_SERVICE_OFFICIAL = '官網求助'

    exports.TITLE_HELP_TYPE = '求助類型'

    exports.TITLE_CONTACT_WAY = '聯繫方式'

    exports.TYPE_VIDEO_LAG = '音視頻卡頓'

    exports.TYPE_CLIENT_CRASH = '系統崩潰'

    exports.TYPE_OTHER = '其他'

    exports.CONTACT_TYPE_qq = 'qq'

    exports.CONTACT_TYPE_PHONE = '電話'

    exports.PLACEHOLDER_DESCRIPTION = '請輸入您的求助說明'

    exports.INFO_CREATE_HELP_SUCCESS = '科技求助已經發送給相關老師，稍後將會與您聯系！'

    exports.UNKNOW_ERROR = '未知錯誤發生了'

    exports.WARING_INVALID_PHONE = '無效的手機號碼'

    exports.WARING_INVALID_QQ = '無效的qq號碼'

    exports.WARING_DESCRIPTION_EMPTY = '描述資訊不能為空'

    exports.SUBMIT_HELP_TOO_FREQUENT = '請不要過於頻繁地提交求助哦~'

    /**
     * =================================================
     * 音视频播放器相关话术
     * =================================================
     */

    exports.MEDIA_PLAYER_KEEP_ON = '請保持音視頻設備開啟'

    exports.MEDIA_PLAYER_FILE_LOADING = '正在加載${fileName}'

    exports.MEDIA_PLAYER_CLOSE_VIDEO = '已開監視器，點擊關閉對方影像'

    exports.MEDIA_PLAYER_OPEN_VIDEO = '已開監視器，點擊開啟對方影像'

    exports.MEIDA_PLAYER_CAMERA_OFF = '對方未開啟監視器'

    exports.MEDIA_PLAYER_MIC_ON = '已開麥克風'

    exports.MEDIA_PLAYER_MIC_OFF = '未開麥克風'

    exports.MEDIA_PLAYER_CLOSE_MIC = '，點擊關閉對方麥克風'

    exports.MEDIA_PLAYER_POPUP = '點擊快顯視窗'

    exports.MEDIA_PLAYER_SWITCH = '點擊切換ppt與視頻視窗'

    exports.MEDIA_PLAYER_VIDEO_DOWNLINK_BANDWIDTH = '接收視頻：'

    exports.MEDIA_PLAYER_AUDIO_DOWNLINK_BANDWIDTH = '接收音訊：'

    exports.MEDIA_PLAYER_VIDEO_UPLINK_BANDWIDTH = '上送視頻：'

    exports.MEDIA_PLAYER_AUDIO_UPLINK_BANDWIDTH = '上送音訊：'

    exports.MEDIA_PLAYER_FOLD = '收起'

    exports.MEDIA_PLAYER_UNFOLD = '展開'

    /**
     * =================================================
     * CEF 相关话术
     * =================================================
     */

    exports.CEF_ERROR_PLAYBACK_AUDIO = '音訊設備發生錯誤啦'

    exports.CEF_ERROR_SYSTEM_NOT_SUPPORT = '你的作業系統不支持此功能，請更換電腦或陞級你的作業系統'

    exports.CEF_ERROR_CAMERA_IS_BUSY = '你的監視器可能被其他應用程序佔用，請檢查'

    exports.CEF_ERROR_OPEN_MIC = '打開麥克風失敗，請重啓用戶端'

    exports.ALERT_CREATE_STREAM_TIMEOUT = '獲取音視頻流超時，請檢查監視器設備並重繪重試。'

    exports.CEF_ERROR_WORK_MIC = '麥克風無法正常工作，請檢查'

    exports.CEF_ERROR_OPEN_SPEAKER = '打開揚聲器失敗，請重啓用戶端'

    exports.CEF_ERROR_CAPTURE_AUDIO = '麥克風採集數據失敗，請重啓用戶端'

    /**
     * =================================================
     * 需要变量替换的一些话术
     * =================================================
     */

    exports.TPL_LOGIN_CONFLICT = '您的帳號/參加碼在${endType}登入，請確認後重新登入！'

    exports.TPL_STUDENT_SEND_TEACHER_GIFT = '<em>${userName}</em>給老師送了一個禮物'

    exports.TPL_TEACHER_RECEIVE_STUDENT_GIFT = '收到來自<em>${userName}</em>的禮物'

    exports.TPL_TEACHER_FORBID_USER_SEND_MESSAGE = '<em>${userName}</em>被老師禁言'

    exports.TPL_CUSTOM_SERVICE_CALL = '點擊確認，呼叫技術支援人員<br />請接起您的手機<em>${mobile}</em>上的來電'

    exports.TPL_DETECT_TOOL_NET_STATUS_SPEED = '<em>${netStatusMsg}</em>，延時${speed}ms'

    exports.TIME_NOCTICE_JOIN_CLASS = '${seconds}s後將重進教室'

    /**
     * =================================================
     * 登录注册
     * =================================================
     */

    exports.LOGIN_REGISTER_LOGIN = '登入'

    exports.LOGIN_REGISTER_REGISTER = '注册'

    exports.LOGIN_REGISTER_LOGIN_WAITING = '登入中…'

    exports.LOGIN_REGISTER_REGISTER_WAITING = '注册中…'

    exports.LOGIN_REGISTER_MOBILE = '請輸入手機號碼'

    exports.LOGIN_REGISTER_SET_PASSWORD = '請設置密碼'

    exports.LOGIN_REGISTER_INPUT_PASSWORD = '請輸入密碼'

    exports.LOGIN_REGISTER_INPUT_VERIFYCODE = '請輸入手機驗證碼'

    exports.LOGIN_REGISTER_SEND_VERIFYCODE = '獲取驗證碼'

    exports.LOGIN_REGISTER_SEND_VERIFYCODE_COUNTING = '秒後重試'

    exports.LOGIN_REGISTER_MOBILE_ERROR = '請輸入正確的手機號碼'

    exports.LOGIN_REGISTER_PASSWORD_ERROR = '請輸入正確的密碼'

    exports.LOGIN_REGISTER_CAPTCHA_ERROR = '請輸入正確的圖形驗證碼'

    exports.LOGIN_REGISTER_VERIFYCODE_ERROR = '請輸入正確的驗證碼'

    exports.LOGIN_REGISTER_DIALOG_TITLE = '確認登入'

    exports.LOGIN_REGISTER_LOGIN_BY_SMS = '簡訊登入'

    exports.LOGIN_REGISTER_LOGIN_BY_PASSWORD = '密碼登入'

    exports.LOGIN_REGISTER_INPUT_CAPTCHA = '請輸入下麵的文字'

    exports.LOGIN_REGISTER_SWITCH_ROLE = '您不具備學生身份，是否開通學生身份？'

    /**
     * =================================================
     * 紧急呼叫（客服电话拨打）
     * =================================================
     */

    exports.CUSTOM_SERVICE_NEED_CALL = '有問題？免費電話求助！'

    exports.CUSTOM_SERVICE_CONFIRM_CALL = '確定呼叫'

    exports.CUSTOM_SERVICE_REJECT_CALL = '沒帶手機'

    exports.CUSTOM_SERVICE_EXTRA_FEE = '（部分用戶因手機套餐原因可能會由運營商收取接聽或漫遊費用）'

    exports.CUSTOM_SERVICE_CALLING = '求助電話呼出中'

    exports.CUSTOM_SERVICE_PICKUP = '請接通<em>010-86448910</em>的來電<br />並等待技術支援人員為您服務'

    exports.CUSTOM_SERVICE_DAIL = '直接撥打求助電話'

    exports.CUSTOM_SERVICE_DAIL_CONTENT
        = '您可以自行撥打技術支援人員電話<br />並等待技術支援人員為您服務<br /><em>4000910910</em>'

    exports.CUSTOM_SERVICE_AUTO_CLOSE = '視窗自動關閉中…'

    exports.CUSTOM_SERVICE_DIALOG_TITLE = '求助客服'

    exports.CUSTOM_SERVICE_QQ_MESSAGE = '選擇技術支援通過qq為你實时解决問題'

    exports.CUSTOM_SERVICE_QQ_SYSTEM_INFO = '系統：{system}，版本號：{system-version}'

    exports.CUSTOM_SERVICE_QQ_BROWSER_INFO = '終端：{browser}，版本號：{browser-version}'

    exports.CUSTOM_SERVICE_QQ_PRIMARY = '技術支援一'

    exports.CUSTOM_SERVICE_QQ_SECONDARY = '技術支援二'

    /**
     * =================================================
     * 设备变更
     * =================================================
     */

    exports.DEVICE_CHANGE_ADD_AUDIO = '當前麥克風已切換到新插入的設備'

    exports.DEVICE_CHANGE_ADD_VIDEO = '當前監視器已切換到新插入的設備'

    exports.DEVICE_CHANGE_DEL_AUDIO = '麥克風設備拔出，已切換到默認設備'

    exports.DEVICE_CHANGE_DEL_VIDEO = '監視器設備拔出，已切換到默認設備'

    exports.DEVICE_CHANGE_RESET = '快速設定'

    /**
     * =================================================
     * 签到
     * =================================================
     */

    exports.SIGNIN_TITLE_HINT = '點名'

    exports.SIGNIN_START = '發起點名'

    exports.SIGNIN_STATUS = '答到情况'

    exports.SIGNIN_TIME_NOTICE = '請設定學生需要在${seconds}秒內響應'

    exports.SIGNIN_ACK_COUNT = '答到${member}人'

    exports.SIGNIN_NACK_COUNT = '未答到${member}人'

    exports.SIGNIN_EXPECT_COUNT = '應到${member}人'

    exports.SIGNIN_LIST_DOWNLOAD = '完整名單下載'

    exports.GROUP_SIGNIN_LIST_DOWNLOAD = '本組名單下載'

    exports.SIGNIN_NO_LIST = '未答到人員名單'

    exports.SINGIN_NO_NOTICE = '系統展示未答到名單中的50人，如需完整名單，請點擊'

    exports.SIGNIN_AGAIN = '再次點名'

    exports.SIGNIN_AGAIN_TIME_NOTICE = '${seconds}秒後可再次發起點名'

    exports.SINGIN_WAIT_TIME_NOTICE = '學生正在陸續答到中，${seconds}秒後可查看結果，請稍後'

    exports.SIGNIN_REPLAY = '答到'

    exports.SIGNIN_REPLAY_TIME_NOTICE = '老師要求您在${seconds}秒內響應點名'

    exports.SIGNIN_RESULT_GETTING = '點名結果統計中'

    exports.SIGNIN_COMPLETE_NOTICE = '點名統計完成'

    exports.SIGNIN_GETTING_RESULT = '查看結果'

    /**
     * =================================================
     * 到课名单
     * =================================================
     */

    exports.JOIN_USERLIST_TITLE_HINT = '提示'

    exports.JOIN_USERLIST_TITLE_LIST = '到課名單'

    exports.JOIN_USERLIST_HINT
        = '到課名單，將記錄報名您課堂的學生的昵稱、最早到來時間、最後離開時間。<br />名單中不包括在教室時間特別短的學生。<br />生成清單過程可能造成卡頓，<em>建議在下課後再使用該功能</em>。'

    exports.JOIN_USERLIST_COPY_HINT = '已生成到課清單。你可以匯出為csv檔案'

    exports.LABEL_CONFIRM = '確認'

    exports.JOIN_USERLIST_CLOSE = '關閉'

    exports.JOIN_USERLIST_FETCH = '生成清單'

    exports.JOIN_USERLIST_FETCHING = '正在生成…'

    exports.JOIN_USERLIST_STUDENT_ID = '學生id'

    exports.JOIN_USERLIST_STUDENT_NAME = '學生昵稱'

    exports.JOIN_USERLIST_LOGIN_TIME = '最早進入時間'

    exports.JOIN_USERLIST_LOGOUT_TIME = '最後離開時間'

    exports.JOIN_USERLIST_GROUP = '分組id'

    exports.JOIN_USERLIST_ENDTYPE = '終端類型'

    exports.JOIN_USERLIST_COPY = '匯出'

    exports.JOIN_USERLIST_STILL_IN = '未離開'

    exports.JOIN_USERLIST_NOBODY_HINT = '暫時沒有到課學生喲'

    /**
     * =================================================
     * 助教链接
     * =================================================
     */

    exports.ASSISTANT_LINK = '助教連結'

    exports.ASSISTANT_LINK_NEW_HINT
        = '[最新更新]助教可以用<em>用戶端</em>登入&錄課&播視頻了哦！（入口：用戶端登入頁右下角）'

    exports.ASSISTANT_LINK_HINT
        = '把助教連結複製、發送給小夥伴，他可以成為助教，直接進入教室。<br />並擁有管理學生發言、禁止學生發言、幫忙錄課等許多許可權。'

    exports.ASSISTANT_LINK_LABEL_NAME = '助教姓名：'

    exports.ASSISTANT_LINK_LABEL_AVATAR = '選擇頭像：'

    exports.ASSISTANT_LINK_DEFAULT_NAME = '助教'

    exports.ASSISTANT_LINK_NAME_MAXLENGTH = '姓名不超過8字'

    exports.ASSISTANT_LINK_NAME_EMPTY = '請輸入助教姓名'

    exports.ASSISTANT_LINK_SUCCESS = '成功創建助教連結，請一定注意保密！'

    exports.ASSISTANT_LINK_COPY_SUCCESS = '複製連結成功'

    exports.ASSISTANT_LINK_FAILURE = '助教連結有誤'

    /**
     * =================================================
     * 课件缩放工具条
     * =================================================
     */

    exports.DOC_QUALITY_LOW = '流暢：使用壓縮課件，翻頁較快。'

    exports.DOC_QUALITY_HIGH = '原圖：課件清晰，但<em>容易卡頓</em>。'

    exports.DOC_FIT_VIEW = '適應'

    exports.DOC_FIT_WIDTH = '填充'

    exports.ALLOW_STUDENT_CHANGE_PPT = '允許：允許學生翻頁。'

    exports.FORBID_STUDENT_CHANGE_PPT = '禁止：禁止學生翻頁。'

    exports.HIDDEN_REMARKINFO = '隱藏：不顯示ppt內部備註文字。'

    exports.SHOW_REMARKINFO = '顯示：顯示ppt內部備註文字。'

    /**
     * =================================================
     * 系统检测工具
     * =================================================
     */

    exports.DETECT_TOOL_DIALOG_TITLE = '系統檢測'

    exports.DETECT_TOOL_CUSTOM_SERVICE = '求助技術支援'

    exports.DETECT_TOOL_TIPS = '解決方法建議：'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_GOOD = '優良-上課流暢'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_OK = '一般-偶有卡頓'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_NORMAL = '較差-經常有卡頓'

    exports.DETECT_TOOL_NET_STATUS_LEGEND_BAD = '很差-無法上課'

    exports.DETECT_TOOL_NET_STATUS_GOOD = '網絡優良'

    exports.DETECT_TOOL_NET_STATUS_OK = '網絡一般'

    exports.DETECT_TOOL_NET_STATUS_POOR = '網絡較差'

    exports.DETECT_TOOL_NET_STATUS_TERRIBLE = '網絡很差'

    exports.DETECT_TOOL_NET_STATUS_DETECT = '網絡連接檢測'

    exports.DETECT_TOOL_NET_STATUS_DETECTING = '網絡檢測中……'

    exports.DETECT_TOOL_NET_STATUS_TIPS_HEADER = '如遇網絡不好，請嘗試如下方法：'

    exports.DETECT_TOOL_NET_STATUS_TIPS_CLOSE_P2P = '關閉迅雷和其他p2p軟件，使用網線連接電腦'

    exports.DETECT_TOOL_NET_STATUS_TIPS_CHECK_LAN = '檢查局域網內是否有其他用戶佔用大量頻寬'

    exports.DETECT_TOOL_NET_STATUS_TIPS_REBOOT = '重啓電腦和路由器'

    exports.DETECT_TOOL_NET_STATUS_NO_RESULT = '未獲取到測速資訊或網絡已斷開，請重測'

    exports.DETECT_TOOL_HELP_NET = '網絡常見問題'

    exports.DETECT_REFRESH_NOTICE = '連不上教室？可以切換網絡並嘗試重繪~'

    exports.DETECT_NET_PROGRAM_REFRESH_NOTICE = '正在重新連接，請稍後…'

    exports.DETECT_TOOL_REDETECT = '重測'

    exports.DETECT_TOOL_SPEAKER_DETECT = '揚聲器檢測'

    exports.DETECT_TOOL_SPEAKER_INITIATING = '揚聲器初始化中……'

    exports.DETECT_TOOL_SPEAKER_TEST_SOUND_PLAYING = '測試音樂播放中……'

    exports.DETECT_TOOL_SPEAKER_HAVE_YOU_HEARD = '您能聽到測試聲音嗎？'

    exports.DETECT_TOOL_SPEAKER_NO_DEVICE = '沒檢測到揚聲器設備'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHECK_PLUG = '查看揚聲器連接是否正常並處於開啟狀態'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHANGE_DEVICE = '切換揚聲器設備'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHANGE_VOLUME = '調節揚聲器音量'

    exports.DETECT_TOOL_SPEAKER_TIPS_CHANGE_VOLUME_OUTER = '調節外置揚聲器音量按鈕'

    exports.DETECT_TOOL_SPEAKER_TIPS_OS_SETTING
        = '打開<span class="os-setting-trigger">揚聲器設定</span>，查看是否揚聲器被禁用'

    exports.DETECT_TOOL_SPEAKER_TIPS_SETTING_MAC = '打開<em>系統偏好設定->聲音->輸出</em>，查看揚聲器設定'

    exports.DETECT_TOOL_SPEAKER_TIPS_SETTING_WINDOWS = '打開<em>開始->控制台->聲音->播放</em>，查看是否揚聲器被禁用'

    exports.DETECT_TOOL_HELP_SPEAKER = '揚聲器常見問題'

    exports.DETECT_TOOL_MIC_DETECT = '麥克風檢測'

    exports.DETECT_TOOL_MIC_DETECTING = '請對著麥克風說話'

    exports.DETECT_TOOL_MIC_DETECTING_TIPS = '說話時建議佩戴耳機關閉音箱外放以避免回聲'

    exports.DETECT_TOOL_MIC_HAS_INPUT = '成功檢測到聲音輸入'

    exports.DETECT_TOOL_MIC_HAS_INPUT_WARNING = '強烈建議關閉外放音箱佩戴耳機避免嘯叫和回音'

    exports.DETECT_TOOL_MIC_NO_INPUT = '沒檢測到聲音輸入'

    exports.DETECT_TOOL_MIC_NO_DEVICE = '沒檢測到麥克風設備'

    exports.DETECT_TOOL_MIC_TIPS_HEADER = '如有問題，請嘗試如下方法：'

    exports.DETECT_TOOL_MIC_TIPS_CHANGE_VOLUME = '調節麥克風音量'

    exports.DETECT_TOOL_MIC_TIPS_CHANGE_DEVICE = '切換麥克風設備'

    exports.DETECT_TOOL_MIC_TIPS_HEADER_UNDETECTED = '請嘗試如下方法：'

    exports.DETECT_TOOL_MIC_TIPS_CHECK_PLUG = '查看麥克風連接是否正常並處於開啟狀態'

    exports.DETECT_TOOL_MIC_TIPS_CHECK_BLOCK = '查看是否瀏覽器和電腦管家軟件攔截了設備使用'

    exports.DETECT_TOOL_MIC_TIPS_OS_SETTING
        = '打開<span class="os-setting-trigger">麥克風設定</span>，查看是否麥克風被禁用'

    exports.DETECT_TOOL_MIC_TIPS_SETTING_MAC = '打開<em>系統偏好設定->聲音->輸入</em>，查看麥克風設定'

    exports.DETECT_TOOL_MIC_TIPS_SETTING_WINDOWS = '打開<em>開始->控制台->聲音->錄製</em>，查看是否麥克風被禁用'

    exports.DETECT_TOOL_HELP_MIC = '麥克風常見問題'

    exports.DETECT_TOOL_CAMERA_DETECT = '監視器檢測'

    exports.DETECT_TOOL_CAMERA_HAS_CAMERA = '您能看到影像嗎？'

    exports.DETECT_TOOL_CAMERA_NO_CAMERA = '沒檢測到監視器設備'

    exports.DETECT_TOOL_CAMERA_TIPS_HEADER = '如果沒有看到影像，請嘗試如下方法：'

    exports.DETECT_TOOL_CAMERA_TIPS_CHECK_PLUG = '查看監視器是否連接正常'

    exports.DETECT_TOOL_CAMERA_TIPS_CHECK_CLOSE_OTHER = '請嘗試關閉其他可能佔用監視器的程式'

    exports.DETECT_TOOL_CAMERA_TIPS_CHANGE_DEVICE = '切換監視器設備'

    exports.DETECT_TOOL_CAMERA_TIPS_OS_SETTING = '監視器設定'

    exports.DETECT_TOOL_CAMERA_TIPS_SETTING_MAC
        = '在<em>蘋果->關於本機->預覽->系統報告->相機/usb</em>中查看監視器設備是否安裝正常'

    exports.DETECT_TOOL_CAMERA_TIPS_SETTING_WINDOWS = '在<em>開始->控制台->裝置管理員</em>中查看監視器設備是否安裝正常'

    exports.DETECT_TOOL_HELP_CAMERA = '監視器常見問題'

    exports.DETECT_TOOL_FINISH = '系統檢測完畢'

    exports.DETECT_TOOL_FINISH_TIPS = '如系統仍有問題，請嘗試重啓用戶端、電腦和路由器，或聯系技術支援協助解决'

    /**
     * =================================================
     * settings
     * =================================================
     */

    exports.SETTINGS_MIC_PREFERENCE_SCALING = '麥克風增强'

    exports.SETTINGS_MIC_PREFERENCE_SCALING_UNIT = 'db'

    exports.SETTINGS_TIP_DETECT_CLOSE = '檢測設備將關閉${services}，是否繼續？'

    exports.SETTINGS_INFO_TIP_OPEN_CAMERA = '如需視頻上課，請點擊打開監視器'

    exports.SETTINGS_INFO_TIP_AUDIO_CLASS_CAMERA_FORBIDDEN = '該課程為音訊直播課，不可使用監視器'

    exports.SETTINGS_INFO_TIP_AUDIO_CLASS_SCREEN_SHARE_FORBIDDEN = '該課程為音訊直播課，不可使用荧幕分享功能'

    exports.SETTINGS_INFO_TIP_AUDIO_CLASS_MEDIA_PLAY_FOBIDDEN = '該課程為音訊直播課，不可播放視頻檔案'

    /**
     * =================================================
     * 媒体服务器切换后的相关提示
     * =================================================
     */

    exports.SWITCH_TIP_CLOSE_CAMERA = '檢測到您網絡波動較大丟包嚴重，可嘗試關閉視頻緩解學生端卡頓'

    exports.SWITCH_TIP_SWITCH_CDN = '檢測到您網絡波動較大丟包嚴重，可嘗試切換線路緩解卡頓'

    exports.SWITCH_TIP_QUALITY = '檢測到您網絡波動較大丟包嚴重，請降低清晰度緩解學生端卡頓'

    exports.SWITCH_TIP_NET_STATUS = '檢測到您網絡波動較大丟包嚴重，請檢查網絡狀況'

    exports.SWITCH_TIP_TEACHER_NET_STATUS = '老師端網絡波動較大，時而會有卡頓現象'

    /**
     * =================================================
     * 底部操作 class ation 相关
     * =================================================
     */
    exports.CLASS_ACTION_TIP_DOWNLOAD_WINDOWS
        = '只有用戶端才支持舉手發言，'
        + '点<a href="http://www.baijiayun.com/default/home/liveclientDownload?type=windows" target="_blank">这里</a>下载'

    exports.CLASS_ACTION_TIP_DOWNLOAD_MAC
        = '只有用戶端才支持舉手發言，'
        + '点<a href="http://www.baijiayun.com/default/home/liveclientDownload?type=mac" target="_blank">这里</a>下载'

    exports.CLASS_ACTION_TIP_DOWNLOAD
        = '只有用戶端才支持舉手發言，'
        + '点<a href="http://www.baijiayun.com/default/home/liveclientDownload?partner_id=32891392&type=windows" target="_blank">这里</a>下载'

    /**
     * =================================================
     * 进入教室过程中的提示
     * =================================================
     */

    exports.ENTER_CLASSROOM_MASTER_SERVER_CONNECTING = '正在連接主服務器'

    exports.ENTER_CLASSROOM_MASTER_SERVER_CONNECT_SUCCESS = '主服務器連接成功'

    exports.ENTER_CLASSROOM_SERVER_INFO_FETCH_SUCCESS = '服務器資訊獲取成功'

    exports.ENTER_CLASSROOM_ROOM_SERVER_CONNECT_SUCCESS = '教室服務器連接成功'

    exports.ENTER_CLASSROOM_ROOM_SERVER_LOGIN_SUCCESS = '教室服務器登入成功'

    exports.ENTER_CLASSROOM_AUTH_TOKEN_FAIL = '非法用戶'

    exports.ENTER_CLASSROOM_OVERMAN = '該房間人數已滿，請稍後重試'

    exports.ROOM_SERVER_LOGIN_CONFLICT_CONFIRM = '該教室已經有老師，進入將導致該老師退出教室，您要繼續進入嗎？'

    /**
     * =================================================
     * 新手引导相关话术
     * =================================================
     */

    exports.USER_GUIDE_DOWNLOAD_TEACHER
        = '用用戶端講課音視頻更流暢，教學功能更豐富，小夥伴們都在用，'
        + '你还等什么？快戳<a href="http://www.baijiayun.com/default/home/liveclientDownload?partner_id=32891392&type=windows" target="_blank">这里</a>下载吧'

    exports.USER_GUIDE_DOWNLOAD_STUDENT
        = '用用戶端聽課音視頻更流暢，小夥伴們都在用，你還等什麼？'
        + '快戳<a href="http://www.baijiayun.com/default/home/liveclientDownload?partner_id=32891392&type=windows" target="_blank">这里</a>下载吧'

    /**
     * =================================================
     * 服务器重连提示
     * =================================================
     */

    exports.RECONNECT_ROOM_SERVER_WAITING = '網絡不給力，請檢查網絡…'

    exports.RECONNECT_ROOM_SERVER_SUB_WAITING = '正在嘗試重新連接'

    exports.ROOM_SERVER_LOGIN_EXPIRED_TIP = '教室已過期'

    /**
     * =================================================
     * 录制课程
     * =================================================
     */

    exports.RECORD_CLASS_REMIND = '錄製已中斷，請重新點擊錄製'

    exports.RECORD_INFO_TIP = '建議開啟錄課，課後上傳重播'

    exports.RECORD_COMPLETE_TIP = '課程錄製完成，<span class="btn-action">打開本地錄課檔案</span>'

    exports.RECORD_STOPPING_TIP = '正在生成本地錄制文件，請稍後...'

    exports.RECORD_RESTART_TIP = '本地錄製已停止，請重新<span class="btn-action">開啟</span>本地錄製'

    /**
     * =================================================
     * 自动录课
     * =================================================
     */

    exports.AUTO_RECORD_START = '課程錄製即將自動開啟'

    exports.AUTO_RECORD_RESTART = '課程錄製將重新開啟'

    exports.AUTO_RECORD_STOP = '課程錄製停止，可在用戶端內上傳給學生回看'

    exports.AUTO_RECORD_CLASS_COUNT_DOWN_TIP = '秒後自動開啟'
    exports.AUTO_RECORD_CANCEL = '取消錄製'
    exports.AUTO_RECORD_LATER = '稍後提醒'

    exports.AUTO_RECORD_MODE_CLOUD_AND_LOCAL = '雲端+本地'

    exports.AUTO_RECORD_MODE_CLOUD = '雲端'

    exports.AUTO_RECORD_MODE_LOCAL = '本地'

    exports.AUTO_RECORD_REASON = '本節課在開課時設定為提供重播'

    exports.AUTO_RECORD_TIP_NET_DISK_EMPTY = '資料存儲空間已滿，無法進行雲端錄製，請擴容後手動開啟錄製'

    exports.NO_RECORD_WHEN_AUTO_RECORD = '系統檢測到沒有開啟雲端錄製，是否開啟雲端錄製'

    /**
     * =================================================
     * 环境监测
     * =================================================
     */

    exports.ENV_DETECT_HEADER = '網絡加速'

    exports.ENV_DETECT_ACTION = '一鍵加速'

    exports.ENV_DETECT_KILLING = '正在優化'

    exports.ENV_DETECT_KILL_COMPLETE = '優化成功'

    exports.ENV_DETECT_PROCESS = '建議關閉的程式'

    /**
     * =================================================
     * CDN 厂商名称
     * =================================================
     */

    exports.CDN_DNION = '帝聯'

    exports.CDN_NET_CENTER = '網宿'

    exports.CDN_CHINA_CACHE = '藍汛'

    /**
     * =================================================
     * 录制
     * =================================================
     */

    exports.RECORD_COLLECTS_LOCAL_RECORD = '本地錄製'

    exports.RECORD_COLLECTS_CLOUD_RECORD = '雲端錄製'

    exports.RECORD_COLLECTS_ALL_RECORD = '本地+雲端錄製'

    exports.RECORD_COLLECTS_CLOUD_RECORD_LIST = '管理雲端重播'

    exports.RECORD_COLLECTS_PRE_START_INFO = '快開啟課程錄製吧'

    exports.RECORD_COLLECTS_CLOUD_RECORD_OVER_TIME = '已過課程結束時間，只可使用本地錄製'

    exports.RECORD_COLLECTS_CLOUD_RECORD_OVER_TIME_WEB = '已過課程結束時間，不可以雲端錄製'

    exports.RECORD_COLLECTS_CLOUD_RECORD_OVER_TIME_PAUSE
        = '課程結束時間已超過15分鐘，雲端錄製暫停後將自動結束，是否結束？'

    exports.RECORD_COLLECTS_CLOUD_RECORD_PAUSING_OVER_TIME
        = '課程結束15分鐘內未恢復錄製，雲端錄製將自動結束，請老師注意'

    exports.CLOUD_RECORD_OVER_TIME_WARNING_INFO_BTN = '我知道了'

    exports.END_RECORD_COLLECTS_PAUSE_RECORD = '暫停'

    exports.END_RECORD_COLLECTS_STOP_RECORD = '停止'

    exports.END_RECORD_THEN = '暫不生成'

    exports.END_RECORD_START_PLAYBACK = '開始生成'

    exports.ALERT_STOP_PUSH_RECORD = '是否結束截圖推流錄製？'

    /**
     * =================================================
     * 录课设置
     * =================================================
     */

    exports.RECORD_SETTINGS_TITLE = '錄課設定'

    exports.RECORD_SETTINGS_AUTO_START = '上課後自動打開'

    exports.RECORD_SETTINGS_AUTO_START_LOCAL = '本地錄製'

    exports.RECORD_SETTINGS_AUTO_START_CLOUD = '雲端錄製'

    exports.RECORD_SETTINGS_RECORD_MODE = '錄課模式'

    exports.RECORD_SETTINGS_RECORD_MODE_PART = '視窗錄製'

    exports.RECORD_SETTINGS_RECORD_MODE_FULLSCREEN = '全屏錄製'

    exports.RECORD_SETTINGS_PATH = '錄課視頻保存到'

    // exports.RECORD_SETTINGS_REMEMBER = '记住选择（可到“更多 - 录课设置”中修改）';

    exports.RECORD_SETTINGS_LOCATION_TIP = '可到“更多-錄課設定”中修改'

    /**
     * =================================================
     * 云端录制
     * =================================================
     */

    exports.CLOUD_RECORD_CONFIRM_START
        = '是否要開啟雲端錄課，課後自動生成課程重播？<br />（現時不支持在上課過程中開啟雲端錄製）'

    exports.CLOUD_RECORD_START_TIP_SDK
        = '雲端錄製直接在雲端服務器錄課，本地不保存錄課<br />' + '檔案，課程結束後10分鐘自動生成課程重播。<br />'

    exports.PUSH_RECORD_START_TIP_SDK
        = '截圖推流錄製需要一直保持用戶端打開並全屏的狀態。<br />'
        + '本地不保存錄課檔案，課程結束後10分鐘自動生成課程重播<br />'
        + '注意事項：<br />'
        + '    1、請勿將錄製端揚聲器關閉，否則錄製不到聲音；<br />'
        + '    2、請勿將用戶端移出錄製視窗外，否則錄製移出的部分顯示黑屏；'

    exports.ALERT_PUSH_RECORD_NETWORK_ERROR = '由於網絡可能已斷開，請檢查網絡後重試'

    exports.CLOUD_RECORD_OVERTIME_STOP_TIP = '已超過課程結束時間8小時，雲端錄製自動停止'

    exports.CLOUD_RECORD_PRE_START_TIP = '開啟雲端錄製，課後自動生成重播'

    exports.CLOUD_RECORD_OVERTIME_TIP = '已過課程結束時間，不可開啟雲端錄課'

    exports.CLOUD_RECORD_RESTART_TIP = '上課過程中如需暫停錄製，可點擊停錄，需要恢復時再次點擊錄製'

    exports.CLOUD_RECORD_WITHOUT_TEACHER_WARNING = '老師未在直播間，禁止開啟雲端錄製'

    /**
     * =================================================
     * 点名
     * =================================================
     */
    exports.SIGININ_SUCCESS = '答到成功'

    /**
     * =================================================
     * 磁盘空间
     * =================================================
     */

    exports.NET_DISK_INFO_TITLE = '提示'

    exports.NET_DISK_INFO_BTN = '我知道了'

    exports.NET_DISK_INFO_POOR_PREFFIX = '您的雲存儲空間僅剩餘'

    exports.NET_DISK_INFO_POOR_SUFFIX
        = 'mb，空間占滿後將不能上傳課件，請<a target="_blank" href="/teacher_center/storage_space">購買</a>更多的雲存儲空間或<a target="_blank" href="/teacher_center/netdisk">清理</a>無用檔案'

    exports.NET_DISK_INFO_POOR_WRITE_PREFFIX = '您的雲存儲空間僅剩餘'

    exports.NET_DISK_INFO_POOR_WRITE_SUFFIX = 'mb，即將無法使用雲端錄製，'

    exports.NET_DISK_INFO_EMPTY
        = '您的雲存儲空間不足，現時無法上傳課件，請立即<a target="_blank" href="/teacher_center/storage_space">購買</a>更多的雲存儲空間或<a target="_blank" href="/teacher_center/netdisk">清理</a>無用檔案'

    exports.NET_DISK_INFO_EMPTY_WRITE_PREFFIX = '您的雲存儲空間已超額'

    exports.NET_DISK_INFO_EMPTY_WRITE_SUFFIX = 'mb，即將無法使用雲端錄製，'

    exports.NET_DISK_INFO_EXCEED_WRITE_PREFFIX = '您的雲存儲空間已超額'

    exports.NET_DISK_INFO_EXCEED_WRITE_SUFFIX = 'mb，已無法使用雲端錄製，'

    /**
     * =================================================
     * 用户列表更多选项按钮
     * =================================================
     */

    exports.MORE_SETTINGS_BUTTON_FORBID_SEND_MESSAGE = '禁止聊天'

    exports.MORE_SETTINGS_BUTTON_UNFORBID_SEND_MESSAGE = '允許聊天'

    /**
     * =================================================
     * 第三方推流服务
     * =================================================
     */

    exports.SERVICE_OF_THIRD_PUSH_STREAM_TITLE = '協力廠商推流服務'

    exports.LABEL_URI_OF_THIRD_PUSH_STREAM = 'rtmp推流地址：'
    exports.LABLE_SERVER_STATUS_NORMAL = '推流服務正常'
    exports.LABLE_TRANSPOND_AUDIO_STREAM = '轉發音訊數據'
    exports.LABLE_SERVER_STATUS_ABNORMAL = '推流服務异常'
    exports.LABLE_SERVER_STATUS_PREPARING = '服務器準備中…'

    exports.BUTTON_REFRESH_LIST = '重繪清單'
    exports.BUTTON_COPY_URI_OF_SERVER = '複製'
    exports.BUTTON_RESTART_SERVER = '重啓服務'
    exports.BUTTON_START_TRANPONDING_STREAM = '開始轉發'
    exports.BUTTON_STOP_TRANPONDING_STREAM = '停止轉發'

    exports.STREAM_INFO_ITEM_FIELD_STREAM_NAME = '流名稱'
    exports.STREAM_INFO_ITEM_FIELD_VIDEO_ENCODER = '視頻編碼'
    exports.STREAM_INFO_ITEM_FIELD_RESOLUTION = '視頻分辯率'
    exports.STREAM_INFO_ITEM_FIELD_AUDIO_ENCODER = '音訊編碼'
    exports.STREAM_INFO_ITEM_FIELD_SAMPLE_RATE = '音訊採樣'
    exports.STREAM_INFO_ITEM_FIELD_STATUS = '狀態'

    exports.STREAM_INFO_STATUS_STREAM_BROKEN = '無數據'
    exports.STREAM_INFO_STATUS_IS_TRANSPONDING = '轉發中'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_SUPPORTED = '不支持'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_TRANSPONDING = '未轉發'

    exports.RESTART_SERVER_FAILED_TIP = '重啓服務失敗'
    exports.COPY_SUCCESS_TIP = '複製成功'
    exports.PUSH_STREAM_FAILED_TIP = '轉發流失敗'
    exports.CAN_NOT_GET_SERVER_URL_TIP = '無法獲取伺服器地址'

    exports.STREAM_INFO_MARK_IS_TRANSPONDING = '轉'

    exports.INFO_NO_DATA_FROM_STREAM = '協力廠商流無數據，請檢查設備和網絡，或重啓服務'

    /**
     * =================================================
     * 双摄像头切换项目
     * =================================================
     */
    exports.WHITEBOARD_NAME = '白板/課件'
    exports.ASSIST_CAMERA = '輔助監視器'
    exports.SCREEN_SHARE = '荧幕分享'

    exports.CLOSE_MEDIA_BEFORE_DETECT = '請先停止音視頻檔案播放'
    exports.CLOSE_DESKTOP_SHARE_BEFORE_DETECT = '請先關閉荧幕分享'

    exports.SETTING_CAMERA_DISABLE = '監視器使用中，暫無法更改設定'
    exports.SETTING_ASSIST_CAMERA_DISABLE = '輔助監視器使用中，暫無法更改設定'
    exports.SETTING_SHARE_DISABLE = '案頭分享使用中，暫無法更改設定'

    /**
     * =================================================
     * 邀请发言
     * =================================================
     */
    exports.MORE_SETTINGS_BUTTON_INVITE_SPEAK_INIT = '邀請上麥'

    exports.MORE_SETTINGS_BUTTON_INVITE_SPEAK_INVITING = '取消邀請'

    exports.MORE_SETTINGS_MARK_INVITING = '邀請中'

    exports.MORE_SETTINGS_MARK_SPEAKING = '發言中'

    exports.MORE_SETTINGS_BUTTON_OPEN_SPEAK_INIT = '強制上麥'

    exports.MORE_SETTINGS_BUTTON_OPEN_SPEAK_OPENING = '打開中'

    exports.MORE_SETTINGS_BUTTON_SPEAK_INVITE_UNSUPPORTED_HOVER_TIP = '該用戶使用網頁版，不支持邀請上麥'

    exports.BUTTON_OPEN_WEBCAM = ' 打開監視器 '

    /**
     * =================================================
     *
     * 第三方推流服务
     * =================================================
     */

    exports.SERVICE_OF_THIRD_PUSH_STREAM_TITLE = '協力廠商推流服務'

    exports.LABEL_URI_OF_THIRD_PUSH_STREAM = 'rtmp推流地址：'
    exports.LABLE_SERVER_STATUS_NORMAL = '推流服務正常'
    exports.LABLE_TRANSPOND_AUDIO_STREAM = '轉發音訊數據'
    exports.LABLE_SERVER_STATUS_ABNORMAL = '推流服務异常'

    exports.BUTTON_COPY_URI_OF_SERVER = '複製'
    exports.BUTTON_RESTART_SERVER = '重啓服務'
    exports.BUTTON_START_TRANPONDING_STREAM = '開始轉發'
    exports.BUTTON_STOP_TRANPONDING_STREAM = '停止轉發'

    exports.STREAM_INFO_ITEM_FIELD_STREAM_NAME = '流名稱'
    exports.STREAM_INFO_ITEM_FIELD_VIDEO_ENCODER = '視頻編碼'
    exports.STREAM_INFO_ITEM_FIELD_RESOLUTION = '視頻分辯率'
    exports.STREAM_INFO_ITEM_FIELD_AUDIO_ENCODER = '音訊編碼'
    exports.STREAM_INFO_ITEM_FIELD_SAMPLE_RATE = '音訊採樣'
    exports.STREAM_INFO_ITEM_FIELD_STATUS = '狀態'

    exports.STREAM_INFO_STATUS_STREAM_BROKEN = '無數據'
    exports.STREAM_INFO_STATUS_IS_TRANSPONDING = '轉發中'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_SUPPORTED = '不支持'
    exports.STREAM_INFO_STATUS_STREAM_IS_NOT_TRANSPONDING = '未轉發'

    exports.RESTART_SERVER_FAILED_TIP = '重啓服務失敗'
    exports.COPY_SUCCESS_TIP = '複製成功'
    exports.PUSH_STREAM_FAILED_TIP = '轉發流失敗'
    exports.CAN_NOT_GET_SERVER_URL_TIP = '無法獲取伺服器地址'
    exports.STREAM_INFO_MARK_IS_TRANSPONDING = '轉'
    /**
     * =================================================
     * 双摄像头切换项目
     * =================================================
     */
    exports.WHITEBOARD_NAME = '白板/課件'
    exports.ASSIST_CAMERA = '輔助監視器'
    exports.SCREEN_SHARE = '荧幕分享'

    exports.SIGNIN_FORBID = '上次點名倒數計時完成的1分鐘後才可發起下一次點名'

    /**
     * =================================================
     * 点名
     * =================================================
     */
    exports.SIGNIN_FORBID = '上次點名倒數計時完成的1分鐘後才可發起下一次點名'

    exports.BEGIN_EXAM_TIP = '確認開啟隨堂考嗎？'

    exports.END_EXAM_TIP = '確認關閉隨堂考嗎？'

    exports.BEGIN_EXAM_INFO = '隨堂考已開啟'

    exports.END_EXAM_INFO = '隨堂考已關閉'

    exports.UNKNOW_EMOTION = '[不支持的表情]'

    /**
     * =================================================
     * 升级浏览器提示
     * =================================================
     */
    exports.UPGRADE_CLOSE_POWER_SAVING_MODE = '關閉省電模式'

    exports.UPGRADE_NOTICE_SAFARI = '您使用的是safari瀏覽器，請確認關閉省電模式，以保證啟用音視頻正常上課'

    exports.UPGRADE_SAFARI_SETTING = 'safari設定-高級'

    exports.UPGRADE_CANCEL_CHECK = '取消勾選'

    exports.UPGRADE_NOTICE_NO_FLASH
        = '系統檢測到你的flash部件無法正常工作，將導致教室功能無法正常使用。<br />請嘗試點擊播放下方視頻，如果不能播放，請下載使用'

    exports.UPGRADE_BROWSER_GOOGLE = '穀歌瀏覽器'

    exports.UPGRADE_FAIL_CONTACT_TEL = '如果問題不能解决，請聯系客服4000-910-910'

    exports.UPGRADE_CLOSE_POWER_SAVING_MODE_CHROME
        = '您使用的是最新版chrome瀏覽器，請關閉省電模式，以保證啟用音視頻正常上課'

    exports.UPGRADE_CHROME_SETTING_STEP_ONE = '進入chrome挿件設定頁面'

    exports.UPGRADE_CHROME_SETTING_STEP_TWO = '勾選始終允許運行adobe flash player'

    exports.UPGRADE_REFRESH_LIVE_ROOM = '重繪教室頁面'

    exports.UPGRADE_NO_FLASH_CAN_NOT_START = '你的瀏覽器未安裝flash挿件，將無法正常上課'

    exports.UPGRADE_INSTALL_GUIDE = '安裝指南'

    exports.UPGRADE_TAKE_A_LOOK = '先看一眼'

    exports.UPGRADE_NOTICE_TO_LOW_BROWSER = '你的瀏覽器難以體驗線上教室的强大功能，建議更換高級瀏覽器'

    exports.UPGRADE_ENABLE_NEW_TECH = '立刻啟用最新科技'

    exports.UPGRADE_BY_REJECT = '湊合用吧'

    exports.FLASH_CAN_NOT_USE = '網頁flash挿件加載不成功，您可以嘗試以下操作'

    exports.CLICK_ALLOW_TIP = '並在提示上選擇“允許”'

    exports.CLICK_INSTALL_TIP = '並安裝'

    exports.CLICK_TIP = '點擊'

    exports.ALLOW_FLASH = '啟用flash'

    exports.DOWNLOAD_FLASH = '下載flash'

    /**
     * =================================================
     * 管理课件
     * =================================================
     */

    exports.DOCUMENT_UPLOAD = '上傳課件'

    exports.DOCUMENT_UPLOAD_ING = '課件上傳中'

    exports.DOCUMENT_UPLOAD_FROM_NETDISK = '從資料庫添加'

    exports.DOCUMENT_HAS_ADD = '已添加課件'

    exports.DOCUMENT_SUPPORT_FORMAT = '支持ppt、pptx、doc、docx、jpg、png、pdf'

    exports.DOCUMENT_MOVE_UP = '上移'

    exports.DOCUMENT_MOVE_DOWN = '下移'

    exports.DOCUMENT_UPLOAD_STAUS_CACEL = '取消上傳'

    exports.DOCUMENT_UPLOAD_STAUS_ING = '上傳中'

    exports.DOCUMENT_UPLOAD_STAUS_FAIL = '上傳失敗'

    exports.DOCUMENT_TRANSFORM_STATUS_FAIL = '轉碼失敗'

    exports.DOCUMENT_TRANSFORM_STATUS_WAIT = '等待轉碼'

    exports.DOCUMENT_TRANSFORM_ING = '轉碼中'

    exports.DOCUMENT_HAS_ADD_STATUS = '已添加'

    exports.DOCUMENT_TRANSFORM_NOTICE = 'wps編輯的檔案請轉換成pdf後上傳'

    exports.DOCUMENT_DEMO_LINK = '點此查看轉換教程'

    exports.DOCUMENT_CAN_USE_STATUS = '可使用'

    exports.DOCUMENT_HAS_BE_CHECKED = '已選'

    exports.DOCUMENT_UPLOAD_ING_NOTICE = '檔案正在上傳中，請稍候…'

    exports.DOCUMENT_MANAGEMENT = '課件管理'

    exports.DOCUMENT_BACK_TO_MANAGEMENT = '返回課件管理'

    exports.SURVEY_PLEASE_INPUT_ANSWER = '請輸入答案'

    exports.PLACEHOLDER_NOITCE_CONTENT = '請輸入公告正文內容'

    exports.PLACEHOLDER_NOITCE_LINK = '請輸入公告跳轉連結（可選）'

    exports.PLACEHOLDER_NOITCE_GROUP_CONTENT = '請輸入通知正文內容'

    exports.PLACEHOLDER_NOITCE_GROUP_LINK = '請輸入通知跳轉連結（可選）'

    exports.NOTICE_LINK_ERROR_HINT = '連結格式不正確'

    exports.KICK_OUT = '踢出教室'

    exports.ENTER_CLASSROOM_KICKED_OUT = '被請出教室後無法再次進入'

    exports.KICKED_OUT_TIP = '您已被請出教室'

    exports.KICKED_OUT_BY_AUDITION_END_TIP = '您的試聽時間已到，若您想要繼續聽課，請您報名後參與！'

    exports.KICKED_OUT_BY_ROOM_DISABLED_TIP = '當前直播間已被禁用，您已被請出直播間'

    exports.ALERT_KICK_OUT_AFTER_CLASS_30_MINUTES = '課程已經結束，歡迎下次繼續觀看'

    exports.CLASS_END_TIP = '老師已經下課了~'

    exports.CLASS_ENDED = '下課時間已到'

    exports.TIME_BEFORE_CLASS_END = '距離下課時間還有${time}秒'

    exports.CLASS_HAS_BEGAN_TIME = '已開課${hours}小時${minutes}分${seconds}秒'

    exports.WARNING_APPLY_SPEAK_STATUS_SWITCH_FREQUENT = '請不要頻繁切換發言狀態'

    /**
     * =================================================
     * 设置主讲人
     * =================================================
     */

    exports.YOU_ARE_PRESENTER = '您被設定為主講老師'

    exports.YOU_ARE_NOT_PRESENTER = '您被收回主講老師許可權'

    exports.SET_USER_PRESENTER_TIP = '主講老師已切換到${username}'

    exports.CANCEL_USER_PRESENTER_TIP = '已收回用戶${username}的主講老師許可權'

    exports.CANCEL_USER_PRESENTER_WHEN_OUT_TIP = '用戶${username}退出教室，已被收回的主講老師許可權'

    exports.OPEN_CAMERA_FAIL_TIP = '打開監視器失敗'

    exports.OPEN_MIC_FAIL_TIP = '打開麥克風失敗'

    exports.PRESENTER_IN = '主講老師已進入教室'

    exports.PRESENTER_OUT = '主講老師已離開教室'

    exports.BJY_SUPPORT = '百家雲提供直播服務'

    exports.CONFIRM_SEND_PRIZE = '是否發送紅包？'

    exports.CPU_MEMORY_PERFORMANCE_WARNING_CPU = '檢測到電腦cpu使用率過高，為保證正常直播，請關閉與直播無關的軟件'

    exports.CPU_MEMORY_PERFORMANCE_WARNING_MEMORY = '檢測到電腦記憶體使用率過高，為保證正常直播，請關閉與直播無關的軟件'

    exports.CPU_MEMORY_PERFORMANCE_WARNING_BOTH
        = '檢測到電腦cpu和記憶體使用率過高，為保證正常直播，請關閉與直播無關的軟件'

    exports.NETWORK_BAD_WARNING = '網絡狀況較差，音視頻有可能發生卡頓'

    exports.CHANGE_LINK_TYPE_DUE_TO_NETWORK = '網絡狀況過差，正在嘗試為你切換至其他連結。'

    exports.LABEL_WHITEBOARD_FILL = '填充'

    exports.LABEL_WHITEBOARD_STROKE = '描邊'

    exports.LABEL_FORBID_RAISE_HAND = '禁止舉手'

    exports.INFO_FORBID_RAISE_HAND = '已禁止舉手'

    exports.INFO_UNFORBID_RAISE_HAND = '已允許舉手'

    exports.INFO_FORBID_OPEN_MIC = '已禁止開啟麥克風'

    exports.INFO_UNFORBID_OPEN_MIC = '已允許開啟麥克風'

    exports.INFO_TEACHER_FORBID_RAISE_HAND = '已禁止舉手'

    exports.LABEL_GUEST = '用戶'

    exports.INFO_CLOUD_RECORD_END_PLAYBACK_START_NEW = '繼續前一次雲端錄製還是開啟新的雲端錄製？'

    exports.INFO_BUTTON_CONTINUE = '繼續錄製'

    exports.INFO_BUTTON_START_NEW = '新的錄製'

    exports.LABEL_GUEST = '用戶'

    exports.SELECT_PROGRAM = '請選擇要共亯的程式'

    exports.CONFIRM_REMOVE_DOCUMENT_TRANSFORM_ING = '檔案正在轉碼中，確定要删除嗎？'

    exports.BUTTON_UPLOAD_PPT_DOCUMENT = '動效ppt'

    exports.BUTTON_CHROME_FLASH_USER_GUIDE1_COMPLETE = '設定完成'

    exports.PRE_STEP = '上一步'

    exports.NEXT_STEP = '下一步'

    exports.TIP_CHROME_FLASH_MORE_SETTING = '以上方法仍然沒有解决問題？'

    exports.VIEW_MORE_SETTING = '查看更多相關設定'

    exports.LABEL_NO_LONGER_REMIND = '不再提示'

    exports.BUTTON_CLOSE = '關閉'

    exports.CHROME_UPGRADE_INSTRUCTION = '您的瀏覽器中的flash player存在异常，請按以下方法正確設定後才能直播'

    exports.CHROME_TIP_FLASH_SETTING_SET = '1.將下圖藍色框標識區域設置為'

    exports.CHROME_TIP_FLASH_SETTING_ALLOW = '在此網站上始終允許'

    exports.CHROME_TIP_FLASH_SETTING_THEN = '，然後'

    exports.CHROME_TIP_FLASH_SETTING_REFRESH = '重繪'

    exports.CHROME_TIP_FLASH_SETTING_BROWSER = '瀏覽器'

    exports.CHROME_TIP_FLASH_DOWNLOAD = '2.若設定後仍顯示該頁面，則需要下載安裝最新的flash player'

    exports.DOWNLOAD_FLASH = '立即下載'

    exports.CHROME_MORE_SETTING_FLASH = '查看更多相關設定'

    /**
     * apple 帮助信息
     */
    exports.APPLE_HELP_INFO = '致電8610-85255961或發郵件至yandong.liu@apple.com'

    exports.TIP_DO_NOT_SUPPORT_LOW_VERSION_IE = '嗚~您的流覽器版本太低了~我們已經不支持ie9以下的版本了！'

    exports.TIP_LOW_VERSION_IE_UPDATE_BROWSER = '1、請陞級瀏覽器'

    exports.TIP_LOW_VERSION_IE_DOWNLOAD_CHROME = '立即下載'

    exports.TIP_LOW_VERSION_IE_CHANGE_MODE = '2、若您使用的是360、qq、搜狗等瀏覽器，請切換到極速模式'

    exports.TIP_LOW_VERSION_IE_CHANGE_BROWSER = '3、更換其他瀏覽器'

    exports.TIP_LOW_VERSION_IE_CLASS_TYPE_LIVE = '雲端直播'

    exports.TIP_LOW_VERSION_IE_CLASS_TYPE_CLASSROOM = '雲端課堂'

    exports.TIP_INVITATION_NAME_INPUT = '請輸入您的昵稱：'

    exports.TIP_INVITATION_NAME_INPUT_MOBILE = '請輸入您的手機號：'

    exports.TIP_INVITATION_NAME_INPUT_MOBILE_WRONG = '請輸入正確的手機號'

    exports.PLACEHOLDER_INVITATION_JOINCODE_INPUT = '您可以向您的直播管理者索要參加碼'

    exports.TIP_INVITATION_GET_JOINCODE = '請輸入您的參加碼：'

    exports.TIP_INVITATION_NAME_SHOULD_NOT_BE_EMPTY = '昵稱不能為空'

    exports.TIP_INVITATION_MOBILE_SHOULD_NOT_BE_EMPTY = '手機號不能為空'

    exports.TIP_INVITATION_JOINCODE_SHOULD_NOT_BE_EMPTY = '參加碼不能為空'

    exports.TIP_INVITATION_JOINCODE_IS_NOT_RIGHT = '請輸入正確的參加碼'

    exports.LOCAL_RECORD_PATH_NULL = '請選擇本地存放視頻路徑'

    exports.INFO_LOCK_SCREEN = '已開啟學生鎖'

    exports.INFO_UNLOCK_SCREEN = '已解鎖'

    exports.INFO_LOCK_SCREEN_STUDENT = '老師已經開啟學生鎖，您現時不能操作其他軟體'

    exports.LABEL_NERVER_PRINT = '不再提示'

    exports.LABEL_LOCK_SCREEN_OPEN = '開啟'

    exports.INFO_LOCK_SCREEN_FIRST = '開啟學生鎖後，使用windows用戶端的學生只能使用本直播軟件。'

    exports.INFO_COLLECT_SYSTEM_SOUND_FIRST
        = '避免您聽到音訊回音，當您開啟採集系統聲音時，您可以降低揚聲器的聲音或者將揚聲器靜音。'

    exports.MEDIA_PLAYER_LOAD_FILE_FAILED = '檔案加載失敗，請確保該檔案是媒體檔案或打開其他檔案'

    exports.CLASS_SWITCH_PARENT_TIP = '進入小班'

    exports.CLASS_SWITCH_CHILD_TIP = '進入大班'

    exports.PARENT_CLASS_SWITCH_PARENT_TIP = '分組討論'

    exports.PARENT_CLASS_SWITCH_CHILD_TIP = '大班集合'

    exports.CLASS_SWITCH_PARENT_SUCCESS_TIP = '已切入大班課'

    exports.CLASS_SWITCH_CHILD_SUCCESS_TIP = '已切入小班課'

    exports.CLASS_SWITCH_ROOM_SERVER_WAITING = '正在切換房間，重新連接中…'

    exports.CLASS_SWITCH_TIP = '確定切換教室嗎？'

    exports.CLASS_SWITCH_TIP_CLOUD_RECORD
        = '<div class="confirm-class-switch-tip">進入大班後，雲端錄製將暫停，需回到小班生成重播</div>'

    exports.CLASS_SWITCH_MEDIA_PLAYER_TIP = '請先停止播放本地音視頻'

    exports.CLASS_SWITCH_THIRD_PUSH_TIP = '請先停止協力廠商推流'

    exports.CLASS_SWITCH_SCREEN_SHAR_TIP = '請先停止案頭共亯'

    exports.CLASS_SWITCH_VIDEO_LAYOUT_TIP = '請先停止視頻佈局'

    exports.CLASS_SWITCH_EXAM_TIP = '請先停止隨堂考試'

    exports.CLASSROOM_ENTER_COUNT_DOWN_LABEL = '直播倒數計時：'

    /**
     * 图片添加至文档
     */
    exports.LABEL_IMAGE = '圖片'

    exports.LABEL_IMAGE_VIEW = '圖片預覽'

    exports.LABEL_IMAGE_DOWNLOAD = '下載圖片'

    exports.LABEL_ADD_TO_DOCUMENT = '添加至課件'

    exports.LABEL_OPEN_ON_BLACKBOARD = '添加並打開'

    exports.INFO_IMAGE_ADD_SUCCESS = '圖片已經成功添加至檔案區'

    exports.INFO_IMAGE_ADD_FAIL = '未能成功添加圖片至檔案'

    exports.WARING_IMAGE_HAS_ADDED = '圖片已添加至檔案，請不要重複添加'

    exports.QRCODE_IMAGE_UPLOAD_DONE = '上傳成功，${countDown}秒後關閉…'

    /**
     * 问答提示
     */
    exports.INFO_QUESTION_ANSWERED = '老師回答了你的問題，快去查看吧~'

    exports.CONFIRM_CLOSE_QUSETION_ANSWER = '您還有內容未發送，確認關閉嗎？'

    /**
     * 浏览器不兼容提示
     */
    exports.BROWSER_NOT_SUPPORT_TIP_IE = '您的流覽器版本過低，請陞級至ie10或以上版本。'

    exports.BROWSER_NOT_SUPPORT_TIP_WECHAT = '暫不支持微信內寘瀏覽器，請轉至其他瀏覽器打開。'

    exports.BROWSER_NOT_SUPPORT_TIP_WEBRTC = '您的的瀏覽器不支持webrtc類型課程，請使用最新版chrome瀏覽器。'

    /**
     * 抽奖
     */

    exports.LOTTERY_STATUS_ING = '抽獎中，剩餘'

    exports.LOTTERY_COMMADN_ING_TIP = '當前抽獎仍然在進行中，是否提前開獎並公佈中獎名單'

    exports.LOTTERY_BUTTON_CONTINUE = '繼續抽獎'

    exports.LOTTERY_BUTTON_BEGIN_NOW = '現在開獎'

    exports.LOTTERY_BEGIN_IN_CHAT = '在聊天區輸入口令參與抽獎'

    exports.LOTTERY_MESSAGE_TIP_BEFORE = '輸入'

    exports.LOTTERY_MESSAGE_TIP_AFTER = '參與抽獎'

    /**
     * 音频设备统一切换
     */
    exports.COMBINED_AUDIO_DEVICE_SWITCH_CONFIRM = '發現相同設備的麥克風/揚聲器，是否啟用？'

    exports.COMBINED_AUDIO_DEVICE_SWITCH_OK = '啟用'

    /*
     * 授权画笔
     */
    exports.PAINT_AUTHORIZE_TIP_ENABLE = '老師已授權你使用畫筆'

    exports.PAINT_AUTHORIZE_TIP_DISABLE = '老師已收回你的畫筆許可權'

    /*
     * 切换布局
     */
    exports.SWITCH_LAYOUT_METTING = '已切換到畫廊佈局'

    exports.SWITCH_LAYOUT_MONKEY = '已切換到三分屏佈局'

    exports.CHECK_GRAYSCALE_FAIL = '切換環境失敗，請聯系百家雲技術支援解决問題'

    exports.SWITCH_LAYOUT_SINGLE = '已切換到單視頻佈局'

    exports.DEVICE_IS_USING = '設備正在使用中'

    exports.LINK_SHARE_SUCCESS = '連結已複製到剪切板'

    exports.SHARE_LABEL_TITLE = '荧幕分享'

    exports.TEXT_NOTICE_LABEL_TITLE = '文字公告'

    exports.IMG_NOTICE_LABEL_TITLE = '圖片公告'

    exports.USER_TAB_ALL = '全部成員'

    exports.USER_TAB_FORBID = '被禁言用戶'

    exports.USER_TAB_KICKOUT = '被踢出用戶'

    exports.RECORD_COMPLETE_LIVE_TIP = '課程錄製完成，'

    exports.OPEN_RECORD_FILE = '打開本地錄課檔案'

    exports.HTTP_REQUEST_ERROR = '網絡請求失敗，請檢查網絡'

    /*
     * 权限控制
     */
    exports.DOCUMENT_CONTROL_AUTHORIZE_TIP_ENABLE = '老師已授權你檔案控制許可權'

    exports.DOCUMENT_CONTROL_AUTHORIZE_TIP_DISABLE = '老師已收回你的檔案控制許可權'

    exports.AUTH_MANAGEMENT_LABEL_TITLE = '許可權管理'

    exports.TEXT_NO_SPEAK_AUTH = '你當前沒有上麥許可權'

    exports.TEXT_SPEAK_AUTH_NO = '老師已收回你的上麥許可權'

    exports.TEXT_NO_NOTICE_AUTH = '你當前沒有發佈公告許可權'

    exports.TEXT_NOTICE_AUTH_NO = '老師已收回你的公告許可權'

    exports.TEXT_NO_DOCUMENT_UPLOAD_AUTH = '你當前沒有檔案上傳許可權'

    exports.TEXT_DOCUMENT_UPLOAD_AUTH_NO = '老師已收回你檔案上傳許可權'

    exports.TEXT_NO_PAINTER_AUTH = '你當前沒有畫筆許可權'

    exports.TEXT_PAINTER_AUTH_NO = '老師已收回你畫筆許可權'

    exports.TEXT_NO_CLASS_START_END_AUTH = '你當前沒有上下課的許可權'

    exports.TEXT_NO_CLOUD_RECORD_AUTH = '你當前沒有雲端錄製的許可權'

    exports.NO_RECORD_AUTH = '使用雲端錄製功能需先開通雲點播產品線，請聯系機构開通！'

    exports.TEXT_NO_FORBID_AND_KICK_AUTH = '你當前沒有禁言和踢人的許可權'

    exports.TEXT_NO_QUIZ_AUTH = '你當前沒有發佈問卷的許可權'

    exports.CONFIRM_RELOAD = '確認要重新進教室嗎？'

    exports.CONFIRM_CLOSE_ROOM = '您確定要停播教室？</br>停播後所有用戶將被踢出教室，教室將關閉且不可再次進入'

    exports.EXTENSION_LABEL_TITLE = '荧幕分享挿件安裝嚮導'

    exports.FORBID_LIVE = '停播'

    exports.AUTO_PLAY_TITLE = '正在進入 '

    exports.SCREEN_SHARE_ERROR = '荧幕分享失敗，請重繪重試'

    exports.PUBLISH_ERROR = '發佈視頻失敗，請重繪重試'

    exports.SUBSCRIBE_ERROR = '加載視頻失敗，請重繪重試'

    exports.WEBRTC_SERVER_CONNECT_TIMEOUT = '視訊伺服器連接超時，請重繪重試'

    exports.CAN_NOT_SCREEN_SHARE_WHEN_CLASS_END = '課程已結束，您無法進行荧幕分享'

    exports.PPT_VIDEO_SWITCH_CONTENT_TIP = '切換視頻視窗與白板位置，學生端是否同步切換？'

    exports.PPT_VIDEO_SWITCH_LOCAL = '僅本地切換'

    exports.PPT_VIDEO_SWITCH_ALL = '同步切換'

    exports.CLASS_HISTORY_BACK_TIP = '返回'

    exports.HISTORY_BACK_ALERT_TIP = '是否離開直播間？'

    exports.RESULT_SCOPE_JINGXI = '金幣'

    exports.TIP_ROOM_SERVER_LOGIN_KICKED_OUT = '你已被踢出教室，無法切換教室'

    exports.LOTTERY_TIME_STOP = '停止抽獎'

    exports.LOTTERY_TIME_STOP_TIP = '確定停止抽獎嗎？'

    exports.TEXT_LOTTERY_SUCCESS = '你已參與抽獎，等待開獎吧~'

    exports.TEXT_LOTTERY_COMMAND_FAIL = '口令輸入錯誤，請重新輸入'

    exports.TEXT_LOTTERY_CLOSE_NO_SUBMIT = '你還沒有提交資訊，確定關閉嗎？'

    exports.TEXT_LOTTERY_TEACHER_OPENED = '當前正在抽獎中'

    exports.TEXT_VOTE_TEACHER_OPENED = '發起投票'

    exports.TEXT_TEACHER_TITLE = '发起投票'

    exports.CLASS_STATUS_STOP_WARMING_UP = '停止暖場'

    exports.TEXT_DETELE_WHITEBOARD = '是否删除當前白板及內容？'

    exports.INFO_PLAYER_LOW_UPLINK_AUDIO_BANDWIDTH = '系統檢測到你的麥克風工作异常，請重新連接該設備'

    exports.INFO_RED_PACKET_CREATE_FAIL = '創建紅包失敗'

    exports.CLEAR_ALL_SHAPE_TIP
        = '<p><icon>！</icon>確認要全部清除嗎？</p><p>此操作會將所有編輯、標注內容全部清除，並且不可恢復。請謹慎操作！<p>'

    exports.CLEAR_ALL_SHAPE_OK_TIP = '全部清除'

    exports.CAN_NOT_PUSH_WEBRTC_STREAM = '當前瀏覽器不支持上麥，請使用最新的chrome或者用戶端'

    exports.TEXT_FORBID_CLASS_START_END = '未到可下課時間'

    exports.CONFIRM_EXIT_CLASSROOM_FORBID_END_CLASS = '當前未到下課時間，仍要退出麼？'

    exports.CONFIRM_LOCATE_PREV_PAGE_END_CLASS = '返回上一頁面將會自動下課，是否返回？'

    exports.CONFIRM_LOCATE_PREV_PAGE_EXIT_CLASSROOM = '返回上一頁面將立即退出直播間，是否返回？'

    exports.BUTTON_SWITCH_MIX_MAIN_USER = '切換視頻佈局'

    exports.TITLE_SIWTCH_MIX_MAIN_USER = '切換後，麥下學生看到的視頻畫面同步顯示'

    exports.MIX_USER_SCREEN_CHANGE_TIP = '${userName}已被切換為主屏'

    exports.LOTTERY_HISTORY_LIST = '中獎記錄'

    /**
     * 低版本 app 不支持作业功能提示
     */
    exports.ALERT_TITLE = '提示'

    exports.ALERT_FIND_LOW_VERSION_APP_IN_CLASS_NOT_SUPPORT_HOMEWORK = '移動端暫不支持該功能。'

    exports.TIP_I_KONW = '我知道了'

    exports.BUTTON_AUTHORIZE_H5_PPT = '授權h5課件'

    exports.BUTTON_AUTHORIZE_H5_PPT_OFF = '取消授權'

    exports.TIP_AUTHORIZE_H5_PPT_ON = '已全體授權h5課件'

    exports.TIP_AUTHORIZE_H5_PPT_OFF = '已全體取消授權h5課件'

    exports.WEBRTC_TYPE_CHANGE_TIP = '本房間已切換線路，即將重新進入房，請稍後…'

    exports.TIP_DISABLE_CONTROLL_FORBID_ALL = '老師已開啟全體禁言'

    exports.TIP_NOT_ALLOW_AUTHORIZE_H5_PPT = '您已禁止學生翻頁，不可授權課件'

    exports.TIP_CANCEL_AUTHORIZE_H5_PPT = '您禁止學生翻頁，已取消課件授權'

    /**
     * safari flv 拉流提示
     */
    exports.LABEL_SAFARI_FLV_PULL_TIPS
        = '無法獲取直播音視頻？打開safari瀏覽器中的“此網站設定…”，將自動播放設定為“允許全部自動播放”。'

    /**
     * =================================================
     * 外接手机摄像头
     * =================================================
     */
    exports.DIALOG_TITLE_PHONE_CAMERA_QRCODE = '掃碼視頻直播'

    exports.TIP_USE_PHONE_CAMERA_QRCODE = '請使用雲端課堂app掃碼直播'

    exports.DIALOG_TITLE_STOP_PHONE_CAMERA = '終止外接設備直播'

    exports.TIP_OPEN_MAIN_CAMERA = '打開主設備監視器'

    /**
     * 屏幕共享音源选择
     */
    exports.SCREEN_SHARE_AUDIO_SELECT_TITLE = '選擇聲音來源'

    exports.SCREEN_SHARE_AUDIO_SELECT_MIC = '共亯麥克風聲音'

    exports.SCREEN_SHARE_AUDIO_SELECT_MIC_TIPS = '荧幕共亯時，學生將聽到您麥克風的聲音'

    exports.SCREEN_SHARE_AUDIO_SELECT_SYSTEM = '共亯系統聲音'

    exports.SCREEN_SHARE_AUDIO_SELECT_SYSTEM_TIPS_1 = '荧幕共亯時，學生將聽到您的系統聲音'

    exports.SCREEN_SHARE_AUDIO_SELECT_SYSTEM_TIPS_2 = '（例如：qq消息提示，音樂、視頻播放等）'

    /**
     * =================================================
     * 美颜
     * =================================================
     */
    exports.DIALOG_TITLE_CLIP_IMAGE = '截圖'

    exports.TIP_INIT_BEAUTY_FAIL = '美顏程式初始化失敗'

    exports.SETTING_LABEL_BEAUTY = '美顏濾鏡'

    exports.SETTING_LABEL_VIRTUAL_BG = '虛擬背景'

    exports.SETTING_TIP_WEB_BEAUTY
        = '美顏濾鏡<br/>1，開啟美顏會佔用一定的記憶體和CPU；<br/>2，為避免您在網頁端使用美顏時卡頓，請您開啟硬體加速；<br/>3，如您需要使用更多美顏&虛擬背景高級效果，請到後臺開通，並在用戶端使用！'

    /**
     * =================================================
     * 选择显身 / 隐身
     * =================================================
     */
    exports.LABEL_ASSISTANT_VISIBLE_TIPS = '若您是課堂授課助教，請用顯身身份進入，其他人可見您'

    exports.LABEL_ASSISTANT_HIDDEN_TIPS = '若您是監課、巡課助教，請使用隱身身份進入，其他人不可見您'

    exports.LABEL_ASSISTANT_ENTER = '進入'

    /**
     * =================================================
     * 摄像机采集模式切换
     * =================================================
     */
    exports.HINT_CLIENT_VIDEO_CAPTURE_MODE_CHANGE_DIALOG_TEXT
        = '監視器採集模式設定會在重新啟動軟件後生效，現在重新啟動軟件？'

    /**
     * =================================================
     * 积分
     * =================================================
     */
    exports.BONUS_BUBBLE_TIP = '積分'

    exports.BONUS_MY_POINTS = '我的積分'

    exports.BONUS_POINTS_RANK = '積分排行'

    exports.BONUS_POINTS_NOT_ENOUNGH = '積分不足本操作暫不發放積分'

    /**
     * =================================================
     * 智写云笔手写板
     * =================================================
     */
    exports.TIP_HAND_WRITTING_BOARD_CONNECTED = '手寫板連接成功'

    exports.TIP_HAND_WRITTING_BOARD_DISCONNECTED = '手寫板已斷開連接'

    exports.TIP_HAND_WRITTING_BOARD_SLEEP = '手寫板已休眠，請按外接手寫板上的電源按鈕喚醒該設備'

    exports.CONFIRM_TITLE_HAND_WRITTING_BOARD_BEFORE_DISCONNECT = '系統提示'

    exports.CONFIRM_CONTENT_HAND_WRITTING_BOARD_BEFORE_DISCONNECT = '是否斷開與外接手寫板的連接'

    exports.CANVAS_SWITCH_TO_WHITEBOARD = '切換到白板'

    exports.CANVAS_SWITCH_TO_DOCUMENT = '切換到課件：${name}'

    /**
     * =================================================
     * 抢答器
     * =================================================
     */

    exports.TIP_USER_OFFLINE = '該學生不在教室'

    exports.TIP_USER_ON_STAGE_ALREADY = '該學生已經上麥'

    exports.TIP_NOT_ALLOW_SPEAK = '當前直播未支持上麥'

    /**
     * =================================================
     * 检测录制
     * =================================================
     */
    exports.TIP_RECORD_SOFTWARE_CHECKED = '程式檢測到您正在進行錄屏，請關閉錄屏軟件後重啓用戶端進行觀看'

    /**
     * =================================================
     * 转播
     * =================================================
     */
    exports.INFO_CAN_NOT_OPERATE_MEDIA_WHEN_TRANSFER_CLASS = '轉播時不能操作音視頻和管理課件相關操作'

    exports.CONFIRM_END_TRANSFER_CLASS = '正在轉播中，確定關閉轉播嗎？'

    exports.INFO_CAN_NOT_PLAY_FILE_BEFORE_TRANSFER_CLASS_END = '轉播結束前不能使用媒體播放~'

    exports.INFO_CAN_NOT_START_TRANSFER_CLASS_BEFORE_START_CLASS = '課程未開始，不能使用轉播~'

    exports.CAN_NOT_STOP_RTMP_PUSH_WHEN_TRANSFER_CLASS_BEGIN = '轉播功能無法禁播'

    exports.COMMON_ERROR_PAGE_TIP_PREFIX = '額..'

    /**
     * =================================================
     * 打开摄像头提示
     * =================================================
     */
    exports.INFO_IF_OPEN_CAMERA = '是否打开摄像头？'

    exports.BUTTON_NOT_OPEN_CAMERA = '不打開'

    exports.BUTTON_OPEN_CAMERA = '打開'

    /**
     * =================================================
     * 字幕
     * =================================================
     */
    exports.BUTTON_CAPTION = '字幕'

    exports.BUTTON_CLOSE_CAPTION = '關閉字幕'

    /**
     * =================================================
     * 福袋
     * =================================================
     */
    exports.TIP_END_LUCKY_BAG = '优惠券停止將無法恢復，請謹慎操作'

    /**
     * =================================================
     * PK 功能
     * =================================================
     */
    exports.TIP_PK_USER_NOT_ENOUGH = '可上麥人數不足'

    exports.TIP_PK_USER_OUT = '已退出教室，請重新設定PK成員'

    /**
     * =================================================
     * 打开网页
     * =================================================
     */

    exports.TIP_CLOSE_WEB_PAGE = '關閉窗口將收回學生頁面，是否繼續？'

    exports.TIP_PAGE_CANCEL = '網頁已被關閉'

    exports.MANAGE_EXPLORER = '瀏覽器'

    exports.ELECTRON_CLIENT_AVSDK_CAN_NOT_PUSH_STREAM_TIP = 'Electron版本不支持使用當前音視頻底層推流，請前往官網下載CEF版本使用！'

    /**
     * =================================================
     * 白板导出
     * =================================================
     */
    exports.BLACKBOARD_EXPORT = '保存板書'

    /**
     * =================================================
     * 自定义推流布局
     * =================================================
     */
    exports.VIDEO_LAYOUT_SETTING = '雲畫布'

    exports.INFO_CAN_NOT_PLAY_FILE_BEFORE_CLOSE_VIDEO_LAYOUT = '關閉雲畫布前不能使用媒體播放'

    exports.INFO_CAN_NOT_SCREEN_SHARE_BEFORE_CLOSE_VIDEO_LAYOUT = '關閉雲畫布前不能使用荧幕共亯'

    exports.INFO_CAN_NOT_PUBLISH_VIDEO_LAYOUT_BEFORE_CLOSE_SCREEN_SHARE = '關閉荧幕共亯前不能使用雲畫布'

    exports.INFO_CAN_NOT_PUBLISH_VIDEO_LAYOUT_BEFORE_CLOSE_MEDIA_FILE = '關閉視頻前不能使用雲畫布'

    exports.INFO_CAN_NOT_PUBLISH_VIDEO_LAYOUT_BEFORE_CLOSE_PLAYBACK = '關閉重播前不能使用雲畫布'

    exports.INFO_PUBLISH_VIDEO_LAYOUT_SHOULD_BE_PRESENTER = '只有主講人才能使用雲畫布'

    /**
     * =================================================
     * 切换 WebRTC 节点
     * =================================================
     */
    exports.BUTTON_SWITCH_WEBRTC_NODE = '切換線路'

    exports.INFO_CAN_NOT_SWITCH_WEBRTC_NODE_IN_WEBRTC_MIX = '非上麦状态不支持切换网络线路'

    /**
     * =================================================
     * 本地录制提示
     * =================================================
     */
    exports.INFO_CONFIRM_STOP_LOCAL_RECORD = '本地錄製中，確定要停止本地錄製嗎？'

    exports.INFO_LOCAL_RECORD_GENERATE = '本地錄製視頻生成中，不能離開直播間。'

    exports.INFO_LOCAL_RECORD_HAS_GENERATE = '本地錄製視頻已生成。'

    /**
     * =================================================
     *  推荐卡片
     * =================================================
     */
    exports.TITLE_RECOMMEND_CARD = '推薦卡片'

    /**
     * =================================================
     *  申请开麦
     * =================================================
     */
    exports.MIC_APPLY_DESC = '申請開麥'

    exports.MIC_REJECT_TIP = '老師已拒絕開啟麥克風'

    exports.MIC_ACCEPT_TIP = '老師已同意開啟麥克風'

    exports.TIP_ON_WALL = '申請已在大屏幕上顯示'

    /**
     * =================================================
     *  cpu 提示
     * =================================================
     */
    exports.TIP_CPU_HIGH_LIMIT_SCREEN_SHARE = "系統檢測當前CPU超過70%，使用“荧幕共亯”會導致直播异常，不支持開啟！"

    exports.TIP_CPU_HIGH_LIMIT_BEAUTY = "系統檢測當前CPU超過70%，開啟“美顏/虛擬背景”會導致直播异常，不支持開啟！"

    exports.TIP_CPU_HIGH_END_SCREEN_SHARE = "系統檢測當前CPU超過80%，使用“荧幕共亯”會導致直播异常，已為您中斷共亯！"

    exports.TIP_CPU_HIGH_END_BEAUTY = "系統檢測當前CPU超過80%，繼續使用“美顏/虛擬背景”會導致直播异常，已為您關閉！"
})
